'use strict';

(function($){
	/*
	 * Vetology.PatientSwissKnife widget
	 *
	 * @description Adds image handling functionality to a Vetology page
	 *              Attached to the body element, and can be accessed from anywhere in the dom via $('body').PatientSwissKnife('instance')
	 *
	 *
	 * @options					See description for each option
	 * @options canvas			The canvas descriptor where things wil be drawned
	 *							image_viewer
	 *								container	The main container of the canvas
	 *								canvas		The actual canvas where the images are rendered
	 *							image_diagnosys
	 *								original The details of the image of the study
	 *									container	The main container of the canvas
	 *									canvas		The actual canvas where the images are rendered
	 *								compare The details of the image that the study is being compared against
	 *									container	The main container of the canvas
	 *									canvas		The actual canvas where the images are rendered
	 * 							layout The format in which images are displayed values are 0 for side by side, 1 for one on top of the other
	 * @options ratio			The ratio of width/height that should be used the images will always use full width of the calculated space and the height will always be the width * ratio
	 * @options body_loading	A class name to add to the body when anything is loading
	 * @options tools			The selectors for the buttons that control the enabled tool/effect/interface
	 * @options interfaces		The selectors for the containers where an interface is located
	 *							interfaces.global is a class that every interface contains so they can all be disabled
	 *							interfaces.image_over is a class that will be used to trigger the event handlers on the images
	 * @options series          Series data for the case.
	 *                          This object contains a lot of data, including matched image info for each case image
	 * @method	See description above each method
	 */
	$.widget("Vetology.PatientSwissKnife", {
        options: {
            transfer_syntaxes: {
                LittleEndianImplicit: {
                    retired: false,
                    TransferSyntaxUID: "1.2.840.10008.1.2",
                    TransferSyntaxname: "Implicit VR Endian",
                    TransferSyntaxDetail: " Default Transfer Syntax for DICOM",
                },
                ImplicitVREndian: {
                    retired: false,
                    TransferSyntaxUID: "1.2.840.10008.1.2",
                    TransferSyntaxname: "Implicit VR Endian",
                    TransferSyntaxDetail: " Default Transfer Syntax for DICOM",
                },
                LittleEndianExplicit: {
                    retired: false,
                    TransferSyntaxUID: "1.2.840.10008.1.2.1",
                    TransferSyntaxname: "Explicit VR Little Endian",
                },
                ExplicitVRLittleEndian: {
                    retired: false,
                    TransferSyntaxUID: "1.2.840.10008.1.2.1",
                    TransferSyntaxname: "Explicit VR Little Endian",
                },
                DeflatedExplicitVRLittleEndian: {
                    retired: false,
                    TransferSyntaxUID: "1.2.840.10008.1.2.1.99",
                    TransferSyntaxname: "Deflated Explicit VR Little Endian",
                },
                BigEndianExplicit: {
                    retired: false,
                    TransferSyntaxUID: "1.2.840.10008.1.2.2",
                    TransferSyntaxname: "Explicit VR Big Endian",
                },
                ExplicitVRBigEndian: {
                    retired: false,
                    TransferSyntaxUID: "1.2.840.10008.1.2.2",
                    TransferSyntaxname: "Explicit VR Big Endian",
                },
                "JPEGBaseline(Process1)": {
                    retired: false,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.50",
                    TransferSyntaxname: "JPEG Baseline (Process 1)",
                    TransferSyntaxDetail: "Default Transfer Syntax for Lossy JPEG 8-bit Image Compression",
                },
                "JPEGBaseline(Processes2&4)": {
                    retired: false,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.51",
                    TransferSyntaxname: "JPEG Baseline (Processes 2 & 4)",
                    TransferSyntaxDetail:
                        "Default Transfer Syntax for Lossy JPEG 12-bit Image Compression(Process 4 only)",
                },
                "JPEGExtended(Processes3&5)": {
                    retired: true,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.52",
                    TransferSyntaxname: "JPEG Extended (Processes 3 & 5) ",
                },
                "JPEGSpectralSelection,Nonhierarchical(Processes6&8)": {
                    retired: true,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.53",
                    TransferSyntaxname: "JPEG Spectral Selection, Nonhierarchical (Processes 6 & 8) ",
                },
                "JPEGSpectralSelection,Nonhierarchical(Processes7&9)": {
                    retired: true,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.54",
                    TransferSyntaxname: "JPEG Spectral Selection,  Nonhierarchical (Processes 7 & 9) ",
                },
                "JPEGFullProgression,Nonhierarchical(Processes10&12)": {
                    retired: true,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.55",
                    TransferSyntaxname: "JPEG Full Progression, Nonhierarchical (Processes 10 & 12) ",
                },
                "JPEGFullProgression,Nonhierarchical(Processes11&13)": {
                    retired: true,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.56",
                    TransferSyntaxname: "JPEG Full Progression, Nonhierarchical (Processes 11 & 13) ",
                },
                "JPEGLossless,Nonhierarchical(Processes14)": {
                    retired: false,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.57",
                    TransferSyntaxname: "JPEG Lossless, Nonhierarchical (Processes 14)",
                },
                "JPEGLossless,Nonhierarchical(Processes15)": {
                    retired: true,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.58",
                    TransferSyntaxname: "JPEG Lossless, Nonhierarchical (Processes 15) ",
                },
                "JPEGExtended,Hierarchical(Processes16&18)": {
                    retired: true,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.59",
                    TransferSyntaxname: "JPEG Extended, Hierarchical (Processes 16  & 18) ",
                },
                "JPEGExtended,Hierarchical(Processes17&19)": {
                    retired: true,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.60",
                    TransferSyntaxname: "JPEG Extended, Hierarchical (Processes 17  & 19) ",
                },
                "JPEGSpectralSelection,Hierarchical(Processes20&22)": {
                    retired: true,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.61",
                    TransferSyntaxname: "JPEG Spectral Selection, Hierarchical (Processes 20 & 22) ",
                },
                "JPEGSpectralSelection,Hierarchical(Processes21&23)": {
                    retired: true,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.62",
                    TransferSyntaxname: "JPEG Spectral Selection, Hierarchical (Processes 21 & 23) ",
                },
                "JPEGFullProgression,Hierarchical(Processes24&26)": {
                    retired: true,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.63",
                    TransferSyntaxname: "JPEG Full Progression,  Hierarchical (Processes 24 & 26) ",
                },
                "JPEGFullProgression,Hierarchical(Processes25&27)": {
                    retired: true,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.64",
                    TransferSyntaxname: "JPEG Full Progression,  Hierarchical (Processes 25 & 27) ",
                },
                "JPEGLossless,Nonhierarchical(Process28)": {
                    retired: true,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.65",
                    TransferSyntaxname: "JPEG Lossless, Nonhierarchical (Process  28) ",
                },
                "JPEGLossless,Nonhierarchical(Process29)": {
                    retired: true,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.66",
                    TransferSyntaxname: "JPEG Lossless, Nonhierarchical (Process  29) ",
                },
                "JPEGLossless,Nonhierarchical,First-OrderPrediction(Processes14[SelectionValue1])": {
                    retired: false,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.70",
                    TransferSyntaxname:
                        "JPEG Lossless, Nonhierarchical, First- Order Prediction(Processes 14 [Selection Value 1])",
                    TransferSyntaxDetail: " Default Transfer Syntax for Lossless JPEG Image Compression",
                },
                "JPEG-LSLosslessImageCompression": {
                    retired: false,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.80",
                    TransferSyntaxname: "JPEG-LS  Lossless  Image Compression",
                },
                "JPEG-LSLossy(Near-Lossless)ImageCompression": {
                    retired: false,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.81",
                    TransferSyntaxname: "JPEG-LS  Lossy (Near- Lossless)  Image Compression",
                },
                JPEG2000LosslessOnly: {
                    retired: false,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.90",
                    TransferSyntaxname: "JPEG 2000 Image Compression (Lossless Only)",
                },
                "JPEG2000ImageCompression(LosslessOnly)": {
                    retired: false,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.90",
                    TransferSyntaxname: "JPEG 2000 Image Compression (Lossless Only)",
                },
                JPEG2000: {
                    retired: false,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.91",
                    TransferSyntaxname: "JPEG 2000 Image Compression ",
                },
                JPEG2000ImageCompression: {
                    retired: false,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.91",
                    TransferSyntaxname: "JPEG 2000 Image Compression ",
                },
                "JPEG2000Part2MulticomponentImageCompression(LosslessOnly)": {
                    retired: false,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.92",
                    TransferSyntaxname: "JPEG 2000 Part 2 Multicomponent Image Compression (Lossless Only)",
                },
                JPEG2000Part2MulticomponentImageCompression: {
                    retired: false,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.93",
                    TransferSyntaxname: "JPEG 2000 Part 2 Multicomponent Image Compression",
                },
                JPIPReferenced: {
                    retired: false,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.94",
                    TransferSyntaxname: "JPIP Referenced",
                },
                JPIPReferencedDeflate: {
                    retired: false,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.95",
                    TransferSyntaxname: "JPIP Referenced Deflate",
                },
                RLELossless: {
                    retired: false,
                    TransferSyntaxUID: "1.2.840.10008.1.2.5",
                    TransferSyntaxname: "RLE Lossless",
                },
                RFC2557MIMEEncapsulation: {
                    retired: false,
                    TransferSyntaxUID: "1.2.840.10008.1.2.6.1",
                    TransferSyntaxname: "RFC 2557 MIME Encapsulation",
                },
                MPEG2MainProfileMainLevel: {
                    retired: false,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.100",
                    TransferSyntaxname: "MPEG2 Main Profile Main Level",
                },
                "MPEG-4AVC/H.264HighProfile/Level4.1": {
                    retired: false,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.102",
                    TransferSyntaxname: "MPEG-4 AVC/H.264 High Profile / Level 4.1",
                },
                "MPEG-4AVC/H.264BD-compatibleHighProfile/Level4.1": {
                    retired: false,
                    TransferSyntaxUID: "1.2.840.10008.1.2.4.103",
                    TransferSyntaxname: "MPEG-4 AVC/H.264 BD-compatible High Profile / Level 4.1",
                },
            },
            sop_class_uids: {
                ComputedRadiographyImageStorage: {
                    SOPClassName: "Computed Radiography Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.1",
                    IODSpecificationText: "Computed Radiography Image IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.2.html",
                },
                DigitalXRayImageStorageForPresentation: {
                    SOPClassName: "Digital X-Ray Image Storage - For Presentation",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.1.1",
                    IODSpecificationText: "Digital X-Ray Image IODSection B.5.1.1",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.26.html",
                },
                DigitalXRayImageStorageForProcessing: {
                    SOPClassName: "Digital X-Ray Image Storage - For Processing",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.1.1.1",
                    IODSpecificationText: "Digital X-Ray Image IODSection B.5.1.1",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.26.html",
                },
                DigitalMammographyXRayImageStorageForPresentation: {
                    SOPClassName: "Digital Mammography X-Ray Image Storage - For Presentation",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.1.2",
                    IODSpecificationText: "Digital Mammography X-Ray Image IODSection B.5.1.2",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.27.html",
                },
                DigitalMammographyXRayImageStorageForProcessing: {
                    SOPClassName: "Digital Mammography X-Ray Image Storage - For Processing",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.1.2.1",
                    IODSpecificationText: "Digital Mammography X-Ray Image IODSection B.5.1.2",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.27.html",
                },
                DigitalIntraOralXRayImageStorageForPresentation: {
                    SOPClassName: "Digital Intra-Oral X-Ray Image Storage - For Presentation",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.1.3",
                    IODSpecificationText: "Digital Intra-Oral X-Ray Image IODSection B.5.1.3",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.28.html",
                },
                DigitalIntraOralXRayImageStorageForProcessing: {
                    SOPClassName: "Digital Intra-Oral X-Ray Image Storage - For Processing",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.1.3.1",
                    IODSpecificationText: "Digital Intra-Oral X-Ray Image IODSection B.5.1.3",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.28.html",
                },
                CTImageStorage: {
                    SOPClassName: "CT Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.2",
                    IODSpecificationText: "Computed Tomography Image IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.3.html",
                },
                EnhancedCTImageStorage: {
                    SOPClassName: "Enhanced CT Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.2.1",
                    IODSpecificationText: "Enhanced CT Image IODSection B.5.1.7",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.38.html#sect_A.38.1",
                },
                LegacyConvertedEnhancedCTImageStorage: {
                    SOPClassName: "Legacy Converted Enhanced CT Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.2.2",
                    IODSpecificationText: "Legacy Converted Enhanced CT Image IODSection B.5.1.7",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.70.html",
                },
                UltrasoundMultiframeImageStorage: {
                    SOPClassName: "Ultrasound Multi-frame Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.3.1",
                    IODSpecificationText: "Ultrasound Multi-frame Image IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.7.html",
                },
                MRImageStorage: {
                    SOPClassName: "MR Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.4",
                    IODSpecificationText: "Magnetic Resonance Image IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.4.html",
                },
                EnhancedMRImageStorage: {
                    SOPClassName: "Enhanced MR Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.4.1",
                    IODSpecificationText: "Enhanced MR Image IODSection B.5.1.6",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.36.html#sect_A.36.2",
                },
                MRSpectroscopyStorage: {
                    SOPClassName: "MR Spectroscopy Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.4.2",
                    IODSpecificationText: "MR Spectroscopy IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.36.html#sect_A.36.3",
                },
                EnhancedMRColorImageStorage: {
                    SOPClassName: "Enhanced MR Color Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.4.3",
                    IODSpecificationText: "Enhanced MR Color Image IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.36.html#sect_A.36.4",
                },
                LegacyConvertedEnhancedMRImageStorage: {
                    SOPClassName: "Legacy Converted Enhanced MR Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.4.4",
                    IODSpecificationText: "Legacy Converted Enhanced MR Image IODSection B.5.1.6",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.71.html",
                },
                UltrasoundImageStorage: {
                    SOPClassName: "Ultrasound Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.6.1",
                    IODSpecificationText: "Ultrasound Image IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.6.html",
                },
                EnhancedUSVolumeStorage: {
                    SOPClassName: "Enhanced US Volume Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.6.2",
                    IODSpecificationText: "Enhanced US Volume IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.59.html",
                },
                SecondaryCaptureImageStorage: {
                    SOPClassName: "Secondary Capture Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.7",
                    IODSpecificationText: "Secondary Capture Image IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.8.html",
                },
                MultiframeSingleBitSecondaryCaptureImageStorage: {
                    SOPClassName: "Multi-frame Single Bit Secondary Capture Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.7.1",
                    IODSpecificationText: "Multi-frame Single Bit Secondary Capture Image IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.8.html#sect_A.8.2",
                },
                MultiframeGrayscaleByteSecondaryCaptureImageStorage: {
                    SOPClassName: "Multi-frame Grayscale Byte Secondary Capture Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.7.2",
                    IODSpecificationText: "Multi-frame Grayscale Byte Secondary Capture Image IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.8.html#sect_A.8.3",
                },
                MultiframeGrayscaleWordSecondaryCaptureImageStorage: {
                    SOPClassName: "Multi-frame Grayscale Word Secondary Capture Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.7.3",
                    IODSpecificationText: "Multi-frame Grayscale Word Secondary Capture Image IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.8.html#sect_A.8.4",
                },
                MultiframeTrueColorSecondaryCaptureImageStorage: {
                    SOPClassName: "Multi-frame True Color Secondary Capture Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.7.4",
                    IODSpecificationText: "Multi-frame True Color Secondary Capture Image IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.8.html#sect_A.8.5",
                },
                "12leadECGWaveformStorage": {
                    SOPClassName: "12-lead ECG Waveform Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.9.1.1",
                    IODSpecificationText: "12-Lead Electrocardiogram IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.34.html#sect_A.34.3",
                },
                GeneralECGWaveformStorage: {
                    SOPClassName: "General ECG Waveform Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.9.1.2",
                    IODSpecificationText: "General Electrocardiogram IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.34.html#sect_A.34.4",
                },
                AmbulatoryECGWaveformStorage: {
                    SOPClassName: "Ambulatory ECG Waveform Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.9.1.3",
                    IODSpecificationText: "Ambulatory Electrocardiogram IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.34.html#sect_A.34.5",
                },
                HemodynamicWaveformStorage: {
                    SOPClassName: "Hemodynamic Waveform Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.9.2.1",
                    IODSpecificationText: "Hemodynamic IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.34.html#sect_A.34.6",
                },
                CardiacElectrophysiologyWaveformStorage: {
                    SOPClassName: "Cardiac Electrophysiology Waveform Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.9.3.1",
                    IODSpecificationText: "Basic Cardiac Electrophysiology IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.34.html#sect_A.34.7",
                },
                BasicVoiceAudioWaveformStorage: {
                    SOPClassName: "Basic Voice Audio Waveform Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.9.4.1",
                    IODSpecificationText: "Basic Voice Audio IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.34.html#sect_A.34.2",
                },
                GeneralAudioWaveformStorage: {
                    SOPClassName: "General Audio Waveform Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.9.4.2",
                    IODSpecificationText: "General Audio Waveform IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.34.html#sect_A.34.10",
                },
                ArterialPulseWaveformStorage: {
                    SOPClassName: "Arterial Pulse Waveform Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.9.5.1",
                    IODSpecificationText: "Arterial Pulse Waveform IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.34.html#sect_A.34.8",
                },
                RespiratoryWaveformStorage: {
                    SOPClassName: "Respiratory Waveform Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.9.6.1",
                    IODSpecificationText: "Respiratory Waveform IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.34.html#sect_A.34.9",
                },
                GrayscaleSoftcopyPresentationStateStorage: {
                    SOPClassName: "Grayscale Softcopy Presentation State Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.11.1",
                    IODSpecificationText: "Grayscale Softcopy Presentation State IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.33.html#sect_A.33.1",
                },
                ColorSoftcopyPresentationStateStorage: {
                    SOPClassName: "Color Softcopy Presentation State Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.11.2",
                    IODSpecificationText: "Color Softcopy Presentation State IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.33.html#sect_A.33.2",
                },
                PseudoColorSoftcopyPresentationStateStorage: {
                    SOPClassName: "Pseudo-Color Softcopy Presentation State Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.11.3",
                    IODSpecificationText: "Pseudo-color Softcopy Presentation State IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.33.html#sect_A.33.3",
                },
                BlendingSoftcopyPresentationStateStorage: {
                    SOPClassName: "Blending Softcopy Presentation State Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.11.4",
                    IODSpecificationText: "Blending Softcopy Presentation State IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.33.html#sect_A.33.4",
                },
                "XA/XRFGrayscaleSoftcopyPresentationStateStorage": {
                    SOPClassName: "XA/XRF Grayscale Softcopy Presentation State Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.11.5",
                    IODSpecificationText: "XA/XRF Grayscale Softcopy Presentation State IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.33.html#sect_A.33.6",
                },
                XRayAngiographicImageStorage: {
                    SOPClassName: "X-Ray Angiographic Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.12.1",
                    IODSpecificationText: "X-Ray Angiographic Image IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.14.html",
                },
                EnhancedXAImageStorage: {
                    SOPClassName: "Enhanced XA Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.12.1.1",
                    IODSpecificationText: "Enhanced X-Ray Angiographic Image IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.47.html",
                },
                XRayRadiofluoroscopicImageStorage: {
                    SOPClassName: "X-Ray Radiofluoroscopic Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.12.2",
                    IODSpecificationText: "X-Ray RF Image IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.16.html",
                },
                EnhancedXRFImageStorage: {
                    SOPClassName: "Enhanced XRF Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.12.2.1",
                    IODSpecificationText: "Enhanced X-Ray RF Image IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.48.html",
                },
                XRay3DAngiographicImageStorage: {
                    SOPClassName: "X-Ray 3D Angiographic Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.13.1.1",
                    IODSpecificationText: "X-Ray 3D Angiographic Image IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.53.html",
                },
                XRay3DCraniofacialImageStorage: {
                    SOPClassName: "X-Ray 3D Craniofacial Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.13.1.2",
                    IODSpecificationText: "X-Ray 3D Craniofacial Image IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.54.html",
                },
                BreastTomosynthesisImageStorage: {
                    SOPClassName: "Breast Tomosynthesis Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.13.1.3",
                    IODSpecificationText: "Breast Tomosynthesis Image IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.55.html",
                },
                IntravascularOpticalCoherenceTomographyImageStorageForPresentation: {
                    SOPClassName: "Intravascular Optical Coherence Tomography Image Storage - For Presentation",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.14.1",
                    IODSpecificationText: "Intravascular OCT IODSection B.5.1.13",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.66.html",
                },
                IntravascularOpticalCoherenceTomographyImageStorageForProcessing: {
                    SOPClassName: "Intravascular Optical Coherence Tomography Image Storage - For Processing",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.14.2",
                    IODSpecificationText: "Intravascular OCT IODSection B.5.1.13",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.66.html",
                },
                NuclearMedicineImageStorage: {
                    SOPClassName: "Nuclear Medicine Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.20",
                    IODSpecificationText: "Nuclear Medicine Image IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.5.html",
                },
                RawDataStorage: {
                    SOPClassName: "Raw Data Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.66",
                    IODSpecificationText: "Raw Data IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.37.html",
                },
                SpatialRegistrationStorage: {
                    SOPClassName: "Spatial Registration Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.66.1",
                    IODSpecificationText: "Spatial Registration IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.39.html#sect_A.39.1",
                },
                SpatialFiducialsStorage: {
                    SOPClassName: "Spatial Fiducials Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.66.2",
                    IODSpecificationText: "Spatial Fiducials IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.40.html",
                },
                DeformableSpatialRegistrationStorage: {
                    SOPClassName: "Deformable Spatial Registration Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.66.3",
                    IODSpecificationText: "Deformable Spatial Registration IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.39.html#sect_A.39.2",
                },
                SegmentationStorage: {
                    SOPClassName: "Segmentation Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.66.4",
                    IODSpecificationText: "Segmentation IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.51.html",
                },
                SurfaceSegmentationStorage: {
                    SOPClassName: "Surface Segmentation Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.66.5",
                    IODSpecificationText: "Surface Segmentation IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.57.html",
                },
                RealWorldValueMappingStorage: {
                    SOPClassName: "Real World Value Mapping Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.67",
                    IODSpecificationText: "Real World Value Mapping IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.46.html",
                },
                SurfaceScanMeshStorage: {
                    SOPClassName: "Surface Scan Mesh Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.68.1",
                    IODSpecificationText: "Surface Scan Mesh IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.68.html",
                },
                SurfaceScanPointCloudStorage: {
                    SOPClassName: "Surface Scan Point Cloud Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.68.2",
                    IODSpecificationText: "Surface Scan Point Cloud IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.69.html",
                },
                VLEndoscopicImageStorage: {
                    SOPClassName: "VL Endoscopic Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.77.1.1",
                    IODSpecificationText: "VL Endoscopic Image IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.32.html#sect_A.32.1",
                },
                VideoEndoscopicImageStorage: {
                    SOPClassName: "Video Endoscopic Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.77.1.1.1",
                    IODSpecificationText: "Video Endoscopic Image IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.32.html#sect_A.32.5",
                },
                VLMicroscopicImageStorage: {
                    SOPClassName: "VL Microscopic Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.77.1.2",
                    IODSpecificationText: "VL Microscopic Image IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.32.html#sect_A.32.2",
                },
                VideoMicroscopicImageStorage: {
                    SOPClassName: "Video Microscopic Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.77.1.2.1",
                    IODSpecificationText: "Video Microscopic Image IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.32.html#sect_A.32.6",
                },
                VLSlideCoordinatesMicroscopicImageStorage: {
                    SOPClassName: "VL Slide-Coordinates Microscopic Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.77.1.3",
                    IODSpecificationText: "VL Slide-coordinates Microscopic Image IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.32.html#sect_A.32.3",
                },
                VLPhotographicImageStorage: {
                    SOPClassName: "VL Photographic Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.77.1.4",
                    IODSpecificationText: "VL Photographic Image IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.32.html#sect_A.32.4",
                },
                VideoPhotographicImageStorage: {
                    SOPClassName: "Video Photographic Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.77.1.4.1",
                    IODSpecificationText: "Video Photographic Image IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.32.html#sect_A.32.7",
                },
                OphthalmicPhotography8BitImageStorage: {
                    SOPClassName: "Ophthalmic Photography 8 Bit Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.77.1.5.1",
                    IODSpecificationText: "Ophthalmic Photography 8 Bit Image IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.41.html",
                },
                OphthalmicPhotography16BitImageStorage: {
                    SOPClassName: "Ophthalmic Photography 16 Bit Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.77.1.5.2",
                    IODSpecificationText: "Ophthalmic Photography 16 Bit Image IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.42.html",
                },
                StereometricRelationshipStorage: {
                    SOPClassName: "Stereometric Relationship Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.77.1.5.3",
                    IODSpecificationText: "Stereometric Relationship IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.43.html",
                },
                OphthalmicTomographyImageStorage: {
                    SOPClassName: "Ophthalmic Tomography Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.77.1.5.4",
                    IODSpecificationText: "Ophthalmic Tomography Image IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.52.html",
                },
                VLWholeSlideMicroscopyImageStorage: {
                    SOPClassName: "VL Whole Slide Microscopy Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.77.1.6",
                    IODSpecificationText: "VL Whole Slide Microscopy Image IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.32.html#sect_A.32.8",
                },
                LensometryMeasurementsStorage: {
                    SOPClassName: "Lensometry Measurements Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.78.1",
                    IODSpecificationText: "Lensometry Measurements IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.60.html#sect_A.60.1",
                },
                AutorefractionMeasurementsStorage: {
                    SOPClassName: "Autorefraction Measurements Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.78.2",
                    IODSpecificationText: "Autorefraction Measurements IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.60.html#sect_A.60.2",
                },
                KeratometryMeasurementsStorage: {
                    SOPClassName: "Keratometry Measurements Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.78.3",
                    IODSpecificationText: "Keratometry Measurements IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.60.html#sect_A.60.3",
                },
                SubjectiveRefractionMeasurementsStorage: {
                    SOPClassName: "Subjective Refraction Measurements Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.78.4",
                    IODSpecificationText: "Subjective Refraction Measurements IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.60.html#sect_A.60.4",
                },
                VisualAcuityMeasurementsStorage: {
                    SOPClassName: "Visual Acuity Measurements Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.78.5",
                    IODSpecificationText: "Visual Acuity Measurements IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.60.html#sect_A.60.5",
                },
                SpectaclePrescriptionReportStorage: {
                    SOPClassName: "Spectacle Prescription Report Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.78.6",
                    IODSpecificationText: "Spectacle Prescription Report IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.35.html#sect_A.35.9",
                },
                OphthalmicAxialMeasurementsStorage: {
                    SOPClassName: "Ophthalmic Axial Measurements Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.78.7",
                    IODSpecificationText: "Ophthalmic Axial Measurements IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.60.html#sect_A.60.6",
                },
                IntraocularLensCalculationsStorage: {
                    SOPClassName: "Intraocular Lens Calculations Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.78.8",
                    IODSpecificationText: "Intraocular Lens Calculations IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.60.html#sect_A.60.7",
                },
                MacularGridThicknessandVolumeReport: {
                    SOPClassName: "Macular Grid Thickness and Volume Report",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.79.1",
                    IODSpecificationText: "Macular Grid Thickness and Volume Report IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.35.html#sect_A.35.11",
                },
                OphthalmicVisualFieldStaticPerimetryMeasurementsStorage: {
                    SOPClassName: "Ophthalmic Visual Field Static Perimetry Measurements Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.80.1",
                    IODSpecificationText: "Ophthalmic Visual Field Static Perimetry Measurements IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.65.html",
                },
                OphthalmicThicknessMapStorage: {
                    SOPClassName: "Ophthalmic Thickness Map Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.81.1",
                    IODSpecificationText: "Ophthalmic Thickness Map IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.67.html",
                },
                CornealTopographyMapStorage: {
                    SOPClassName: "Corneal Topography Map Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.82.1",
                    IODSpecificationText: "Corneal Topography Map IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.73.html",
                },
                BasicTextSR: {
                    SOPClassName: "Basic Text SR",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.88.11",
                    IODSpecificationText: "Basic Text SR IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.35.html#sect_A.35.1",
                },
                EnhancedSR: {
                    SOPClassName: "Enhanced SR",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.88.22",
                    IODSpecificationText: "Enhanced SR IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.35.html#sect_A.35.2",
                },
                ComprehensiveSR: {
                    SOPClassName: "Comprehensive SR",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.88.33",
                    IODSpecificationText: "Comprehensive SR IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.35.html#sect_A.35.3",
                },
                Comprehensive3DSR: {
                    SOPClassName: "Comprehensive 3D SR",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.88.34",
                    IODSpecificationText: "Comprehensive 3D SR IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.35.html#sect_A.35.13",
                },
                ProcedureLog: {
                    SOPClassName: "Procedure Log",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.88.40",
                    IODSpecificationText: "Procedure Log IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.35.html#sect_A.35.7",
                },
                MammographyCADSR: {
                    SOPClassName: "Mammography CAD SR",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.88.50",
                    IODSpecificationText: "Mammography CAD SR IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.35.html#sect_A.35.5",
                },
                KeyObjectSelection: {
                    SOPClassName: "Key Object Selection",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.88.59",
                    IODSpecificationText: "Key Object Selection Document IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.35.html#sect_A.35.4",
                },
                ChestCADSR: {
                    SOPClassName: "Chest CAD SR",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.88.65",
                    IODSpecificationText: "Chest CAD SR IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.35.html#sect_A.35.6",
                },
                XRayRadiationDoseSR: {
                    SOPClassName: "X-Ray Radiation Dose SR",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.88.67",
                    IODSpecificationText: "X-Ray Radiation Dose SR IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.35.html#sect_A.35.8",
                },
                ColonCADSR: {
                    SOPClassName: "Colon CAD SR",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.88.69",
                    IODSpecificationText: "Colon CAD SR IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.35.html#sect_A.35.10",
                },
                ImplantationPlanSRDocumentStorage: {
                    SOPClassName: "Implantation Plan SR Document Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.88.70",
                    IODSpecificationText: "Implantation Plan SR Document IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.35.html#sect_A.35.12",
                },
                EncapsulatedPDFStorage: {
                    SOPClassName: "Encapsulated PDF Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.104.1",
                    IODSpecificationText: "Encapsulated PDF IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.45.html#sect_A.45.1",
                },
                EncapsulatedCDAStorage: {
                    SOPClassName: "Encapsulated CDA Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.104.2",
                    IODSpecificationText: "Encapsulated CDA IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.45.html#sect_A.45.2",
                },
                PositronEmissionTomographyImageStorage: {
                    SOPClassName: "Positron Emission Tomography Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.128",
                    IODSpecificationText: "Positron Emission Tomography Image IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.21.html",
                },
                EnhancedPETImageStorage: {
                    SOPClassName: "Enhanced PET Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.130",
                    IODSpecificationText: "Enhanced PET Image IODSection B.5.1.16",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.56.html",
                },
                LegacyConvertedEnhancedPETImageStorage: {
                    SOPClassName: "Legacy Converted Enhanced PET Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.128.1",
                    IODSpecificationText: "Legacy Converted Enhanced PET Image IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.72.html",
                },
                BasicStructuredDisplayStorage: {
                    SOPClassName: "Basic Structured Display Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.131",
                    IODSpecificationText: "Basic Structured Display IOD",
                    IODSpecificationLink:
                        "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.33.html#sect_A.33.5",
                },
                RTImageStorage: {
                    SOPClassName: "RT Image Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.481.1",
                    IODSpecificationText: "RT Image IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.17.html",
                },
                RTDoseStorage: {
                    SOPClassName: "RT Dose Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.481.2",
                    IODSpecificationText: "RT Dose IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.18.html",
                },
                RTStructureSetStorage: {
                    SOPClassName: "RT Structure Set Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.481.3",
                    IODSpecificationText: "RT Structure Set IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.19.html",
                },
                RTBeamsTreatmentRecordStorage: {
                    SOPClassName: "RT Beams Treatment Record Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.481.4",
                    IODSpecificationText: "RT Beams Treatment Record IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.29.html",
                },
                RTPlanStorage: {
                    SOPClassName: "RT Plan Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.481.5",
                    IODSpecificationText: "RT Plan IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.20.html",
                },
                RTBrachyTreatmentRecordStorage: {
                    SOPClassName: "RT Brachy Treatment Record Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.481.6",
                    IODSpecificationText: "RT Brachy Treatment Record IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.30.html",
                },
                RTTreatmentSummaryRecordStorage: {
                    SOPClassName: "RT Treatment Summary Record Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.481.7",
                    IODSpecificationText: "RT Treatment Summary Record IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.31.html",
                },
                RTIonPlanStorage: {
                    SOPClassName: "RT Ion Plan Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.481.8",
                    IODSpecificationText: "RT Ion Plan IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.49.html",
                },
                RTIonBeamsTreatmentRecordStorage: {
                    SOPClassName: "RT Ion Beams Treatment Record Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.1.1.481.9",
                    IODSpecificationText: "RT Ion Beams Treatment Record IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.50.html",
                },
                RTBeamsDeliveryInstructionStorage: {
                    SOPClassName: "RT Beams Delivery Instruction Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.34.7",
                    IODSpecificationText: "RT Beams Delivery Instruction IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.64.html",
                },
                GenericImplantTemplateStorage: {
                    SOPClassName: "Generic Implant Template Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.43.1",
                    IODSpecificationText: "Generic Implant Template IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.61.html",
                },
                ImplantAssemblyTemplateStorage: {
                    SOPClassName: "Implant Assembly Template Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.44.1",
                    IODSpecificationText: "Implant Assembly Template IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.62.html",
                },
                ImplantTemplateGroupStorage: {
                    SOPClassName: "Implant Template Group Storage",
                    SOPClassUID: "1.2.840.10008.5.1.4.45.1",
                    IODSpecificationText: "Implant Template Group IOD",
                    IODSpecificationLink: "http://dicom.nema.org/Dicom/2013/output/chtml/part03/sect_A.63.html",
                },
            },
            patient: {},
            stack_compare: {},
            cases: {},
            image_loader: [],
            reports: {},
            pagination: {},
            workers: 1,
            threshold_changed: 0,
            available_studies: 0,
            load_manager: {
                total: 0,
                loaded: 0,
                images: {},
                downloaded: {},
            },
            update_search: false,
            canvas: {
                image_viewer: {
                    container: ".vetology_iv_canvas_container",
                    canvas: ".vetology_iv_canvas_canvas",
                },
                image_diagnosys: {
                    original: {
                        container: ".vetology_canvas_1_container",
                        canvas: ".vetology_canvas_1",
                    },
                    compare: {
                        container: ".vetology_canvas_2_container",
                        canvas: ".vetology_canvas_2",
                    },
                    layout: 0,
                },
            },
            ratio: 0.5,
            body_loading: ".patientswissknife_loading",
            downloadBuckets: [
                "https://tlakdev.vetology.net/",
                /*"https://file-server-1.vetology.net/",
					"https://file-server-2.vetology.net/",
					"https://file-server-3.vetology.net/",
					"https://file-server-4.vetology.net/",
					"https://file-server-5.vetology.net/"
					"https://file-server-6.vetology.net/",
					"https://file-server-7.vetology.net/",
					"https://file-server-8.vetology.net/",
					"https://file-server-9.vetology.net/",
					"https://file-server-10.vetology.net/",
					"https://file-server-11.vetology.net/",
					"https://file-server-12.vetology.net/",
					"https://file-server-13.vetology.net/",
					"https://file-server-14.vetology.net/",
					"https://file-server-15.vetology.net/",
					"https://file-server-16.vetology.net/",
					"https://file-server-17.vetology.net/",
					"https://file-server-18.vetology.net/",
					"https://file-server-19.vetology.net/",
					"https://file-server-20.vetology.net/",
					"https://file-server-21.vetology.net/",
					"https://file-server-22.vetology.net/",
					"https://file-server-23.vetology.net/",
					"https://file-server-24.vetology.net/",
					"https://file-server-25.vetology.net/",
					"https://file-server-26.vetology.net/",
					"https://file-server-27.vetology.net/",
					"https://file-server-28.vetology.net/",
					"https://file-server-29.vetology.net/",
					"https://file-server-30.vetology.net/"*/
            ],
            cornerstone: {
                elements: [],
                tools: {
                    active: {
                        leftMouse: "wwwc",
                        centerMouse: "pan",
                        scrollMouse: "stackScrollWheel",
                        rightMouse: "zoom",
                        touch: "lengthTouch",
                        multiTouch: "panMultiTouch",
                        pinch: "zoomTouchPinch",
                        touchAndDrag: "wwwcTouchDrag",
                    },
                    configZoom: {
                        /*invert: true,
							"minScale": 0.0,
							"maxScale": 20.0,*/
                        preventZoomOutsideImage: true,
                    },
                    configPanMultitouch: {
                        testPointers: function (eventData) {
                            return eventData.numPointers >= 3;
                        },
                    },
                    orientationMarkers: {
                        drawAllMarkers: true,
                    },
                    brush: {
                        draw: 1,
                        radius: 1,
                        hoverColor: "#357CA5",
                        dragColor: "#00A65A",
                        overlayColor: "#FF5555",
                    },
                },
                buttons: {
                    parent: ".interface_tools",
                },
            },
            tools: {
                layout: ".patientswissknife_layout",
                image_viewer: ".patientswissknife_image_viewer",
                image_diagnosys: ".patientswissknife_image_diagnosys",
                loadSeries: ".activate_series",
            },
            interfaces: {
                global: ".interface_manager",
                image_viewer: {
                    main: ".interface_image_viewer",
                    active: false,
                    series: 0,
                },
                image_diagnosys: {
                    main: ".interface_image_diagnosys",
                    active: false,
                    series: 0,
                },
            },
            update_annotations: false,
        },
        radReportsViewed: [],
        aiReportsViewed: [],

        /*
         * Vetology.PatientSwissKnife._init
         *
         * @description	Initializes toolset behavior behavior
         *
         * @return NULL
         *
         */
        _init: function () {
            var o = this;

            var copyToClipboard = function (textToCopy) {
                let textArea = $("<textarea></textarea>");
                let success = false;
                textArea.css({ position: "fixed", opacity: 0, top: 0, right: 0, bottom: 0, left: 0 });

                textArea.val(textToCopy);
                $("body").append(textArea);
                textArea[0].select();
                success = document.execCommand("copy");
                if (!success) {
                    console.error("Could not copy to clipboard: " + textToCopy);
                }
                textArea.remove();
                return success;
            };

            if (!Modernizr.canvas) {
                o._abortUnsupported();
                return;
            }
            /*var index = 0;
				var colors = ["FF355E","FD5B78","FF6037","FF9966","FF9933","FFCC33","FFFF66","FFFF66","CCFF00","66FF66","AAF0D1","50BFE6","FF6EFF","EE34D2","FF00CC","FF00CC","AEFEAE"];
				setInterval(
					function(){
						var color = colors[index];
						index ++;
						if(typeof colors[index] == "undefined"){
							index = 0;
						}
						$(".learn_amie .apply_image_match_icon .vetology-amie .brain").css({color: "#" + color});
					}, 100
				);*/
            $(".interface_image_diagnosys").css({ height: $(window).height() - 100 });
            o._adjustRenderedStudiesHeight();
            $("body").VetologyCache();
            var text = $(".load_pending_text").html();
            $("body").Vetology("vetologyLoadStart", text, text + "<br>This is taking longer than usual...");
            $("body").on("click", ".popup_close", function () {
                o._closePopupError();
            });
            let $caseProcessingStatus = $(".case-status.processing");
            if ($caseProcessingStatus.length) {
                // case dicoms still processing.  Check periodically if finished
                o._monitorCaseProcessingStatus();
            }
            $.when($("body").VetologyCache("isReady")).then(function () {
                o.options.connected = $("body").data("connected") == 1;
                o.options.id = $("body").data("case_id");
                o.options.download_started_at =
                    window.performance &&
                    window.performance.now &&
                    window.performance.timing &&
                    window.performance.timing.navigationStart
                        ? window.performance.now() + window.performance.timing.navigationStart
                        : Date.now();
                o.options.download_ended_at = o.options.download_started_at;
                $("body").Vetology("vetologyLoadStart", "Series information ready<br>Loading interface...");
                var purchased = $("body").data("purchased");
                var canceled = $("body").data("canceled");
                var transaction = $("body").data("transaction");
                o.options.isReportView = $("body").data("report") == "yes";
                o.options.pid = $("body").data("pid");
                o.options.patient.name = $("body").data("patient");
                o.options.patient.series_preload = $("body").data("series_preload");
                o.options.patient.species = {
                    changed: false,
                    current: $(".species_tag").val(),
                    save: false,
                    newSpecies: null,
                };
                o.options.search_config = {
                    id: o.options.id,
                    threshold: parseFloat($("body").data("threshold")),
                    limit: parseInt($("body").data("limit"), 10),
                    rotated: parseInt($("body").data("rotated"), 10) == 1 ? true : false,
                    image_format: parseInt($("body").data("image_format"), 10) == 1 ? 1 : 0,
                    compare_layout: parseInt($("body").data("compare_layout"), 10) == 1 ? 1 : 0,
                    pagination_format:
                        parseInt($("body").data("pagination_format"), 10) == 1
                            ? 1
                            : parseInt($("body").data("pagination_format"), 10) == 2
                            ? 2
                            : 0,
                };
                o.options.threshold_changed = o.options.search_config.threshold;
                o.options.related = $(".study_related_json").text();
                o.options.reports = $(".purchased_reports_json").text();
                try {
                    o.options.reports = JSON.parse(o.options.reports);
                } catch (e) {
                    o.options.reports = {};
                }
                try {
                    o.options.related = JSON.parse(o.options.related);
                } catch (e) {
                    o.options.related = [];
                }
                o._loadAIConfig();
                var loadedBase = true;
                $.each(o.options.related, function (i, r) {
                    /*Load study*/
                    o._loadStudy(r, function (failed) {
                        if (failed) {
                            if (r == o.options.id) {
                                loadedBase = false;
                            }
                            console.log("failed");
                            console.log(r);
                            console.log(o.options.id);
                            return true;
                        }
                        if (r == o.options.id || !loadedBase) {
                            if (!loadedBase) {
                                o.options.id = r;
                            }
                            var url = window.location.search.substr(1).split("&");
                            var image_viewer = false;
                            var image_diagnosys = false;
                            $.each(url, function (i, view) {
                                view = view.split("=");
                                if (view.length > 1 && $.inArray(view[0], ["view"]) > -1) {
                                    switch (view[0]) {
                                        case "view":
                                            if (view[1] == "iv") {
                                                image_viewer = true;
                                            }
                                            if (view[1] == "im") {
                                                image_diagnosys = true;
                                            }
                                            break;
                                    }
                                }
                            });
                            if (o.options.isReportView) {
                                setTimeout(function () {
                                    $("a.patientswissknife_image_viewer").click();
                                }, 150);
                            } else if (purchased == 1 && transaction != 0) {
                                setTimeout(function () {
                                    $("a.manage_licenses").click();
                                }, 150);
                            } else if (canceled == 1) {
                                setTimeout(function () {
                                    $("a.manage_licenses").click();
                                }, 150);
                            } else if (image_viewer) {
                                setTimeout(function () {
                                    $("a.patientswissknife_image_viewer").click();
                                }, 150);
                            } else if (image_diagnosys) {
                                setTimeout(function () {
                                    $("a.patientswissknife_image_diagnosys").click();
                                }, 150);
                            } else {
                                setTimeout(function () {
                                    $("a.patientswissknife_image_viewer").click();
                                }, 150);
                            }
                            setTimeout(function () {
                                $(".sidebar_auto_activate").click().removeClass("sidebar_auto_activate");
                                if (!o.options.isReportView) {
                                    if (purchased == 1 && transaction != 0) {
                                        o._activatePurchaseCheck(transaction);
                                    } else if (canceled == 1) {
                                        o._activatePurchaseCancel();
                                    }
                                } else {
                                    if (purchased == 1 && transaction != 0) {
                                        o._activatePurchaseCheckPremiumPlans(transaction);
                                    } else if (canceled == 1) {
                                        o._activatePurchaseCancelPremiumPlans();
                                    }
                                }
                            }, 100);
                        }
                        /*o._setCurrentCaseSeries(r);*/
                        o._renderSeries(o.options.cases[r], r);
                    });
                });
            });

            $("body").on("click", ".search-keyword-btn", function (e) {
                o._onClickSearchByKeyword(e);
            });
            $("body").on("click", ".apply_ask_aime_button", function (e) {
                o._onClickAskAime(e);
            });
            $("body").on("click", ".copy-clipboard", function () {
                let selector = $(this).attr("data-report");
                copyToClipboard($(selector).text());
            });
            $("body").on("click", ".get-std-deviation", function (event) {
                const $el = $(event.target);
                const crypt = $el.data("crypt");
                $.get(
                    "patient-manager/calc-image-std-deviation",
                    {
                        crypt: crypt,
                    },
                    null,
                    "json"
                ).done(function (data, textStatus, jqXHR) {
                    if (data.success) {
                        $el.parent().html(data.std_deviation);
                    } else {
                        $el.parent().html("could not calculate");
                    }
                });
            });

            const correctedImagesSwitch = document.querySelector("on-off-switch.show-corrected-images");
            if (correctedImagesSwitch) {
                this.correctedImagesSwitch = correctedImagesSwitch;
                correctedImagesSwitch.addEventListener(
                    "on-off-switch-changed-state",
                    this.onCorrectedImagesSwitch.bind(this)
                );
            }

        },
        /*
         * Vetology.PatientSwissKnife._getSeriesInformation
         *
         * @description	Loads all series;
         *
         * @return NULL
         *
         */
        _setCurrentCaseSeries: function (r) {
            var o = this;
            $.each(o.options.cases[r], function (i, s) {
                o._cornerStoneLoadSeries(s);
            });
        },
        /*
         * Vetology.PatientSwissKnife._getSeriesInformation
         *
         * @description	Loads all series;
         *
         * @return NULL
         *
         */
        _getSeriesInformation: function (series_id, callback) {
            var o = this;
            $("body").Vetology("vetologyLoadEnd");
            $("body").Vetology(
                "vetologyLoadStart",
                "Gathering Study information",
                "<br>This is taking longer than usual..."
            );
            var url = "/patient-manager?a=1&id=" + series_id;
            $.ajax({
                type: "GET",
                url: url,
                dataType: "JSON",
                success: function (data) {
                    data.series_id = series_id;
                    callback(data);
                },
            }).fail(function (jqXHR, textStatus, errorThrown) {
                var error = errorThrown;
                if (jqXHR.statusCode().status == 504) {
                    error =
                        "Timeout error. Can not load case at this time.  There may be unfinished images being processed for this case. \n" +
                        "Please try again later, after images have fully been processed.";
                } else {
                    error =
                        "An error has occurred when loading this case.  Please try refreshing the page after a short time.";
                }
                alert(error);
            });
        },
        /*
         * Vetology.PatientSwissKnife._renderSeries
         *
         * @description	Loads series for a study;
         *
         * @return NULL
         *
         */
        _renderSeries: function (series, case_id) {
            var o = this;
            var target = $('[data-series_id="' + case_id + '"]');
            $.each(series, function (i, s) {
                if (
                    $.inArray(s.modality, ["SC", "CR", "DR", "DX"]) !== -1 ||
                    (s.modality == "US" && s.sop_class_uid != "UltrasoundMultiframeImageStorage")
                ) {
                    target.find('.series_loader_iv[data-series="' + i + '"]').data("matches", 0);
                    $.each(s.dicoms, function (did, dicom) {
                        o._imagePrepare(dicom.id, function (crypt) {
                            o._getCaseSeries(
                                [crypt],
                                function (data) {
                                    var imageIds = [];
                                    $.each(data.imageIds, function (t, url) {
                                        imageIds.push("vetology:" + url);
                                    });
                                    data.imageIds = imageIds;
                                    o._pushImageQueue(imageIds, 0);
                                    o.options.stack_compare[crypt] = data;
                                    o.options.cases[case_id][i].stack_compare = data;
                                    o.options.cases[case_id][i].dicoms[did].stack_compare = data;
                                    /*preloader  o._cornerStoneLoadSeries(o.options.cases[case_id][i], false, false, true);*/
                                    var matches = target
                                        .find('.series_loader_iv[data-series="' + i + '"]')
                                        .data("matches");
                                    var c = data.has_matches ? data.imageIds.length : 0;
                                    matches += c;
                                    target.find('.series_loader_iv[data-series="' + i + '"]').data("matches", matches);
                                    target
                                        .find('.series_loader_iv[data-series="' + i + '"]')
                                        .removeClass("pending_matches")
                                        .find(".ai_diagnose_matches")
                                        .html("AI matches: " + matches);
                                    target
                                        .find('.series_loader_im[data-series="' + i + '"]')
                                        .removeClass("pending_matches")
                                        .find(".ai_diagnose_matches")
                                        .html("AI matches: " + c);
                                },
                                case_id
                            );
                        });
                    });
                }
            });
        },
        /*
         * Vetology.PatientSwissKnife._loadStudy
         *
         * @description	Loads a study for later usage;
         *
         * @return NULL
         *
         */
        _pushImageQueue: function (imageIds, i) {
            var o = this;
            $.when($("body").VetologyCache("imageReady", imageIds[i], 3)).then(function () {
                i++;
                if (imageIds[i]) {
                    //o._pushImageQueue(imageIds, i);
                }
            });
        },
        /*
         * Vetology.PatientSwissKnife._loadStudy
         *
         * @description	Loads a study for later usage;
         *
         * @return NULL
         *
         */
        _loadStudy: function (r, callback, optgroup, switch_first) {
            var o = this;
            o._getSeriesInformation(r, function (data) {
                if (data.series.length === 0) {
                    o.options.failed_load = data.series_id; // loading failures are series specific
                    callback(true);
                    return false;
                }
                if ($.inArray(data.modality, ["SC", "CR", "DR", "DX", "US"]) !== -1) {
                    /*Series need to be reformatted, split onto each image 1 series*/
                    var series_id = 0,
                        current_series,
                        final_series = {};
                    $.each(data.series, function (i, s) {
                        series_id = i > series_id ? i : series_id;
                    });
                    $.each(data.series, function (i, s) {
                        if (s.count > 1 && s.sop_class_uid != "UltrasoundMultiframeImageStorage") {
                            var se = {};
                            $.each(s, function (b, v) {
                                if ($.inArray(b, ["count", "dicoms", "id", "index", "number", "stack"]) === -1) {
                                    se[b] = v;
                                }
                            });
                            se.count = 1;
                            var ci = 0;
                            const ordered = {};
                            Object.keys(s.dicoms)
                                .sort()
                                .forEach(function (key) {
                                    const ikey = parseInt(key);
                                    ordered[ikey] = s.dicoms[key];
                                });

                            $.each(ordered, function (c, d) {
                                series_id++;
                                d.number = 0;
                                var newSeries = $.extend({}, se);
                                newSeries.dicoms = { 0: d };
                                newSeries.id = s.id + "." + series_id;
                                newSeries.number = series_id;
                                newSeries.index = 0;
                                newSeries.stack = {
                                    currentImageIdIndex: 0,
                                    imageDataSet: { 0: s.stack.imageDataSet[ci] },
                                    imageIds: [s.stack.imageIds[ci]],
                                };
                                final_series[series_id] = newSeries;
                                if (data.preload && data.preload_image == s.stack.imageIds[ci]) {
                                    current_series = series_id;
                                    o.options.patient.series_preload = series_id;
                                }
                                ci++;
                            });
                        } else {
                            final_series[i] = s;
                            if (data.preload && i == data.preload) {
                                current_series = i;
                                o.options.patient.series_preload = i;
                            }
                        }
                    });
                    data.series = final_series;
                }
                var series = data.series;
                $.each(series, function (i, s) {
                    series[i].case_id = data.case_id;
                    series[i].modality = data.modality;
                    series[i].cid = data.id;
                    var imageIds = [];
                    $.each(s.stack.imageIds, function (t, url) {
                        imageIds.push("vetology:" + url);
                    });
                    series[i].stack.imageIds = imageIds;
                    series[i].evalReportUrl = false;
                    if (data.availableReportList && data.availableReportList.length > 0) {
                        if (data.availableReportList[0].urlReport) {
                            series[i].evalReportUrl = data.availableReportList[0].urlReport;
                        }
                    }
                });
                o.options.cases[r] = series;
                o.options.available_studies++;
                $("body").Vetology("vetologyLoadEnd");
                var hide = r != o.options.id;
                var study =
                    '<div class="study_series_selector ' + (hide ? "hide" : "") + '" data-series_id="' + data.id + '">';
                var active = false;
                $.each(series, function (i, ser) {
                    if (typeof current_series == "undefined") {
                        if (data.currentImageId) {
                            $.each(series, function (j, serie) {
                                $.each(serie.dicoms, function (k, dcm) {
                                    if (dcm.image_id == data.currentImageId) {
                                        current_series = j;
                                        return;
                                    }
                                });
                                if (current_series) {
                                    return;
                                }
                            });
                        }
                        if (!current_series) {
                            current_series = i;
                        }
                    }
                    let studyHtml = "";
                    if (i === current_series) {
                        studyHtml += o._getSeriesHTML(ser, true, hide, i, data, true, data.modality);
                        studyHtml += o._getSeriesHTML(ser, true, hide, i, data, false, data.modality);
                    } else {
                        studyHtml += o._getSeriesHTML(ser, false, hide, i, data, true, data.modality);
                        studyHtml += o._getSeriesHTML(ser, false, hide, i, data, false, data.modality);
                    }
                    const studyElems = new DOMParser().parseFromString(studyHtml, "text/html").body;
                    const imgs = studyElems.querySelectorAll("div.series_loader_iv img");
                    let intervals = [];
                    imgs.forEach((img, idx) => {
                        if (img && typeof ser.dicoms == "object" && typeof ser.dicoms[ser.index] == "object") {
                            img.dataset.flip = ser.dicoms[ser.index].transformation.flip;
                            img.dataset.rotation = ser.dicoms[ser.index].transformation.rotation;
                            if (
                                ser.dicoms[ser.index].transformation.rotation != 0 ||
                                ser.dicoms[ser.index].transformation.flip
                            ) {
                                if (ser.dicoms[ser.index].transformation.flip) {
                                    // wait until image is loaded to flip
                                    intervals[idx] = setInterval(() => {
                                        const imgClasses = img.className.split(" ");
                                        if (imgClasses.length > 0) {
                                            const curImage = document.querySelector(
                                                'img[class~="' + imgClasses[0] + '"]'
                                            );
                                            if (curImage) {
                                                const imgSrc = curImage.getAttribute("src");
                                                if (imgSrc && !imgSrc.includes("loading")) {
                                                    clearInterval(intervals[idx]);
                                                    curImage.style.transform = "scaleX(-1) ";
                                                }
                                            }
                                            if (curImage) {
                                                const imgSrc = curImage.getAttribute("src");
                                                if (imgSrc && !imgSrc.includes("loading")) {
                                                    clearInterval(intervals[idx]);
                                                    curImage.style.transform = "scaleX(-1) ";
                                                }
                                            }
                                        }
                                    }, 1000);
                                } else {
                                    img.style.transform = "";
                                }
                                if (ser.dicoms[ser.index].transformation.rotation != 0) {
                                    // wait until image is loaded to rotate
                                    intervals[idx] = setInterval(() => {
                                        const imgClasses = img.className.split(" ");
                                        if (imgClasses.length > 0) {
                                            const curImage = document.querySelector(
                                                'img[class~="' + imgClasses[0] + '"]'
                                            );
                                            if (curImage) {
                                                const imgSrc = curImage.getAttribute("src");
                                                if (imgSrc && !imgSrc.includes("loading")) {
                                                    clearInterval(intervals[idx]);
                                                    curImage.style.transform = `rotate(${
                                                        ser.dicoms[ser.index].transformation.rotation
                                                    }deg)`;
                                                }
                                            }
                                        }
                                    }, 1000);
                                }
                            } else {
                                img.style.transform = "";
                            }
                        }
                    });
                    study += studyElems.innerHTML;
                });
                study += "</div>";
                $(".rendered_studies").append(study);
                o._adjustRenderedStudiesHeight();
                o._loadStudySelector(r, optgroup, switch_first);
                if (r == o.options.id || o.options.failed_load == data.series_id) {
                    o.options.series = {
                        data: {
                            loaded: series[current_series],
                            all: series,
                        },
                        current: {
                            image_viewer: current_series,
                            ai: current_series,
                        },
                    };
                    o.options.interfaces.image_viewer.series = current_series;
                    o.options.interfaces.image_diagnosys.series = current_series;
                    o._enableEventHandlers();
                    if (o.options.failed_load == data.series_id) {
                        o.options.id = r;
                        $(".study_selector").change();
                    }
                    o.options.failed_load = false;
                }
                $(".pop_content").popover();
                if (typeof callback == "function") {
                    callback();
                }
            });
        },
        /*
         * Vetology.PatientSwissKnife._getTransferSyntax
         *
         * @description	Returns the transfer syntax information;
         *
         * @return NULL
         *
         */
        _getTransferSyntax: function (syntax) {
            var html = "<tr><td>Transfer Syntax UID</td><td>";
            if (typeof this.options.transfer_syntaxes[syntax] != "undefined") {
                var s = this.options.transfer_syntaxes[syntax];
                html += s.TransferSyntaxUID + "</td></tr>";
                html += "<tr><td>Transfer Syntax Name</td><td>" + s.TransferSyntaxname + "</td></tr>";
                html +=
                    "<tr><td>Transfer Syntax Information</td><td>" +
                    s.TransferSyntaxDetail +
                    (s.retired ? '&nbsp;&nbsp;<span class="label label-danger">(RETIRED)</span>' : "") +
                    "</td></tr>";
                return html;
            }
            return html + syntax + "</td></tr>";
        },
        /*
         * Vetology.PatientSwissKnife._getSOPClass
         *
         * @description	Returns the SOP class information;
         *
         * @return NULL
         *
         */
        _getSOPClass: function (sop_class) {
            var html = "<tr><td>SOP Class Name</td><td>";
            if (typeof this.options.sop_class_uids[sop_class] != "undefined") {
                var s = this.options.sop_class_uids[sop_class];
                html += s.SOPClassName + "</td></tr>";
                html += "<tr><td>SOP Class UID</td><td>" + s.SOPClassUID + "</td></tr>";
                html +=
                    '<tr><td>SOP Class IOD Specification</td><td><a href="' +
                    s.IODSpecificationLink +
                    '" target="_blank">' +
                    s.IODSpecificationText +
                    "</td></tr>";
                return html;
            }
            return html + sop_class + "</td></tr>";
        },
        /*
         * Vetology.PatientSwissKnife._getSeriesHTML
         *
         * @description	Loads a selector for a study;
         *
         * @return NULL
         *
         */
        _getSeriesHTML: function (series, active, hide, i, data, viewer, modality) {
            var withmatches = $.inArray(modality, ["SC", "CR", "DR", "DX"]) !== -1;
            var study = "";
            var o = this;
            if (typeof series.dicoms[series.index] == "undefined") {
                $.each(series.dicoms, function (l, dicom) {
                    series.index = l;
                    return false;
                });
            }
            var crypt = series.dicoms[series.index].id;
            o._imagePrepare(crypt);
            study +=
                '<div class="interface_manager ' +
                (viewer
                    ? "interface_image_viewer series_total series_loader_iv"
                    : "interface_image_diagnosys series_loader_im hide") +
                " series_loader " +
                (!active && !hide ? "active active_series series_clicker" : "") +
                '" data-series="' +
                i +
                '"  data-image_id="' +
                series.dicoms[series.index].image_id +
                '">';
            if (active) {
                study += '<div class="series_separator"></div>';
            }
            if (viewer) {
                study += '<span class="series_activator"></span>';
            } else {
                study += '<span class="series_activator series_activator_alt"></span>';
            }
            if (series.dicoms[series.index].excluded_for_telerad) {
                study +=
                    '<span class="not-selected-for-telerad" style="position:absolute;bottom:3px;left:50%;transform:translateX(-50%);z-index:9;pointer-events:none;color:#ff3b30;background:rgba(0,0,0,0.6);font-weight:bold;font-size:10px;padding:1px 5px;border-radius:2px;white-space:nowrap;">Not selected for telerad</span>';
            }
            study +=
                '<a data-html="true" data-placement="right" data-toggle="popover" data-trigger="click" title="Series Information" data-container="body" data-content=\'';
            study += '<table class="table table-striped table-condensed table_small">';
            study += "<tbody>";
            study += "<tr><td>Series Description</td><td>" + series.description.replace("'/g", "") + "</td></tr>";
            study +=
                "<tr><td>" +
                (series.multiframe ? "Frames in Multiframe Image" : "Images in Series") +
                "</td><td>" +
                series.count +
                "</td></tr>";
            study += "<tr><td>Modality</td><td>" + series.modality + "</td></tr>";
            study += "<tr><td>Series Number</td><td>" + series.number + "</td></tr>";
            study += "<tr><td>Patient Orientation</td><td>" + series.patient_orientation + "</td></tr>";
            study += "<tr><td>Patient Position</td><td>" + series.patient_position + "</td></tr>";
            study += o._getTransferSyntax(series.transfer_syntax_uid);
            study += o._getSOPClass(series.sop_class_uid, series);
            study += "<tr><td>Implementation Class UID</td><td>" + series.implementation_class_uid + "</td></tr>";
            study += "<tr><td>Photometric Interpretation</td><td>" + series.photometric_interpretation + "</td></tr>";
            study +=
                '<tr><td>Standard Deviation</td><td class="std_deviation"><a class="get-std-deviation" href="#" data-crypt="' +
                crypt +
                '">Click to calculate</a></td></tr>';
            study += "</tbody>";
            study += "</table>";
            study +=
                '\' href="#" class="vetology_pd pop_content series_information" data-index="2" data-original-title="Study Information"><span class="vetology-faq label label-primary"></span></a>';
            if (withmatches && !o.options.isReportView) {
                if (viewer) {
                    study +=
                        '<span data-index="' +
                        i +
                        '" data-togglepanel=".patientswissknife_image_diagnosys" class="ai_diagnose_matches label label-warning vetology_menu_offcanvas_toggle_alt series_index_selector_span" data-target=".vetology_menu_right" data-toggletab=".vetology_ai_settings" data-trigger=".vetology_menu_right">AI matches: <span class="vetology-loop spin_label"></span></span>';
                } else {
                    study +=
                        '<span data-index="' +
                        i +
                        '" data-togglepanel=".patientswissknife_image_diagnosys" class="ai_diagnose_matches label label-warning" data-target=".vetology_menu_right" data-toggletab=".vetology_ai_settings" data-trigger=".vetology_menu_right">AI matches: <span class="vetology-loop spin_label"></span></span>';
                }
            }
            study +=
                '<img src="/download/loading" data-tn="4" class="' +
                o.options.image_loader[series.dicoms[series.index].id].id +
                (!active ? " grouped_series_image_active" : "") +
                '">';
            if (
                series.dicoms[series.index].description != null &&
                series.dicoms[series.index].description != "(no value available)" &&
                series.dicoms[series.index].description != ""
            ) {
                study +=
                    '<span class="series_description label label-primary">' +
                    series.dicoms[series.index].description +
                    "(" +
                    (series.multiframe ? "Multiframe " : "") +
                    series.count +
                    " image" +
                    (series.count > 1 ? "s" : "") +
                    ")</span>";
            } else {
                study +=
                    '<span class="series_description label label-primary">(' +
                    (series.multiframe ? "Multiframe " : "") +
                    series.count +
                    " image" +
                    (series.count > 1 ? "s" : "") +
                    ")</span>";
            }
            if (data.description != null && data.description != "(no value available)" && data.description != "") {
                study += '<span class="series_study_description label label-primary">' + data.description + "</span>";
            }
            if (
                series.patient_orientation != null &&
                series.patient_orientation != "(no value available)" &&
                series.patient_orientation != ""
            ) {
                study +=
                    '<span class="series_patient_orientation label label-primary">' +
                    series.patient_orientation +
                    "</span>";
            }
            if (
                series.patient_position != null &&
                series.patient_position != "(no value available)" &&
                series.patient_position != ""
            ) {
                study +=
                    '<span class="series_patient_position label label-primary">' + series.patient_position + "</span>";
            }
            study += '<span class="series_modality label label-primary">' + data.modality + "</span>";
            study += '<span class="series-image_id">' + series.dicoms[series.index].image_id + "</span>";
            study += '<div class="progress">';
            if (viewer) {
                study +=
                    '<div class="progress-bar progress-bar-warning progress-bar-striped active" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%">';
            } else {
                study +=
                    '<div class="progress-bar progress-bar-success progress-bar-striped active" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%">';
            }
            study += "<span>0% Complete (loading)</span>";
            study += "</div>";
            study += "</div>";
            study += "</div>";
            return study;
        },
        /*
         * Vetology.PatientSwissKnife._loadStudySelector
         *
         * @description	Loads a selector for a study.  Orders the series in chronological order
         *
         * @return NULL
         *
         */
        _loadStudySelector: function (r, optgroup, switch_first) {
            var o = this;
            var study = o.options.cases[r];
            var m;
            var study_selector = typeof optgroup != "undefined" ? optgroup : $(".patient_" + o.options.pid);
            var new_option = "";
            try {
                if (typeof optgroup != "undefined") {
                    new_option = $(
                        '<option value="' +
                            r +
                            '" data-case_id="' +
                            Object.values(study)[0].case_id +
                            '">' +
                            study_selector.attr("label") +
                            "</option>"
                    );
                } else {
                    var c;
                    $.each(study, function (i, s) {
                        c = s.stack.imageDataSet[0];
                        return false;
                    });
                    new_option =
                        '<option value="' +
                        r +
                        '"data-case_id="' +
                        Object.values(study)[0].case_id +
                        '">Study @ ' +
                        c.scheduled_date +
                        ": Case ID " +
                        Object.values(study)[0].case_id +
                        "</option>";
                    new_option = $(new_option);
                }
            } catch (e) {
                new_option = $('<option value="' + r + '">' + study_selector.attr("label") + "</option>");
            }
            o._insertStudyOption(study_selector, new_option);
            if (o.options.available_studies > 1) {
                $(".study_selector").addClass("multi_studies");
            }
            if (switch_first) {
                $(".study_selector").val(r).change();
            } else {
                if (r == o.options.id) {
                    // set the initial option to the one associated with this case id
                    $(".study_selector").val(o.options.id).change();
                }
                // if refreshing the page after changing image match settings, relaod the previously selected study
                var imgMatchParams = o._getPerformImageMatchParams();
                if (imgMatchParams) {
                    o._restoreReloadedStudyImgAndPerformImgMatch(study_selector, imgMatchParams);
                }
            }
        },
        /**
         *
         * Vetology.PatientSwissKnife._insertStudyOption
         *
         * @param $study_selector
         * @param $new_option
         * @private
         */
        _insertStudyOption: function ($study_selector, $new_option) {
            var newOptText = $new_option.text();
            var inserted = false;
            $("option", $study_selector).each(function (i, el) {
                var optText = $(el).text();
                if (optText < newOptText) {
                    $("option", $study_selector).eq(i).before($new_option);
                    inserted = true;
                    return false;
                }
            });

            if (!inserted) {
                $study_selector.append($new_option);
            }
        },
        /*
         * Vetology.PatientSwissKnife._checkReloadPageForImageParingChanges
         *
         * @description	reloads previous study/image and peforms image match
         *
         * @return NULL
         *
         */

        _restoreReloadedStudyImgAndPerformImgMatch: function (study_selector, imgMatchParams) {
            if (
                imgMatchParams.studyIdx > 0 &&
                study_selector.children("option").length - 1 == imgMatchParams.studyIdx
            ) {
                $(".study_selector")[0].selectedIndex = imgMatchParams.studyIdx;
                $(".study_selector").change();
                if (imgMatchParams.imgIdx > 0) {
                    setTimeout(function () {
                        $(".study_series_selector")
                            .not(".hide")
                            .children(".series_loader[data-series=" + imgMatchParams.imgIdx + "]")
                            .not(".hide")
                            .children("span.series_activator")
                            .trigger("click");
                        setTimeout(function () {
                            $("span.apply_image_match_button", "div.apply_image_match").trigger("click");
                        }, 2000);
                    }, 3000);
                } else {
                    setTimeout(function () {
                        $("span.apply_image_match_button", "div.apply_image_match").trigger("click");
                    }, 1000);
                }
            } else if (imgMatchParams.studyIdx == 0 && study_selector.children("option").length == 1) {
                if (imgMatchParams.imgIdx > 0) {
                    setTimeout(function () {
                        $(".study_series_selector")
                            .not(".hide")
                            .children(".series_loader[data-series=" + imgMatchParams.imgIdx + "]")
                            .not(".hide")
                            .children("span.series_activator")
                            .trigger("click");
                        setTimeout(function () {
                            $("span.apply_image_match_button", "div.apply_image_match").trigger("click");
                        }, 1000);
                    }, 3000);
                } else {
                    setTimeout(function () {
                        $("span.apply_image_match_button", "div.apply_image_match").trigger("click");
                    }, 1000);
                }
            }
        },

        /*
         * Vetology.PatientSwissKnife._loadAIConfig
         *
         * @description	Loads the configuration for AI;
         *
         * @return NULL
         *
         */
        _loadAIConfig: function () {
            var o = this;
            $(".search_limit").on("change", function () {
                var limit = parseInt($(this).val(), 10);
                if (o.options.search_config.limit != limit) {
                    if ($.inArray(o.options.search_config.limit, [10, 20, 30 /*,40,50,60,70,80,90,100*/]) == -1) {
                        $(".search_limit").val(o.options.search_config.limit);
                    } else {
                        o.options.search_config.limit = limit;
                        o.options.update_search = true;
                    }
                }
            });
            var toggler = $(".threshold_renderer").find(".gauge_toggler");
            var toggler_handle = $(".threshold_renderer").find(".gauge_toggler_handle");
            toggler.slider({
                value: o.options.search_config.threshold * 100,
                min: 35,
                max: 55,
                step: 0.5,
                slide: function (event, ui) {
                    $(".threshold_renderer").attr("class", "threshold_renderer " + o._getThresholdClass(ui.value));
                    o.options.search_config.threshold = ui.value / 100;
                    toggler_handle.find("span").html(ui.value);
                    o.options.update_search = true;
                },
                create: function () {
                    $(".threshold_renderer").attr(
                        "class",
                        "threshold_renderer " + o._getThresholdClass(o.options.search_config.threshold * 100)
                    );
                    toggler_handle.find("span").html((o.options.search_config.threshold * 100).toFixed(0));
                },
            });
        },
        /*
         * Vetology.PatientSwissKnife._getThresholdClass
         *
         * @description	Provides a class given a threshold amount
         *
         * @return NULL
         *
         */
        _getThresholdClass: function (amount) {
            switch (true) {
                case amount == 0:
                    return "threshold_danger";
                case amount < 40:
                    return "threshold_low";
                case amount < 60:
                    return "threshold_perfect";
                case amount < 70:
                    return "threshold_warning";
                default:
                    return "threshold_danger";
            }
        },
        /*
         * Vetology.PatientSwissKnife._getCaseSeries
         *
         * @description	Loads the series with a given configuration;
         *
         * @return NULL
         *
         */
        _getCaseSeries: function (ids, callback, case_id) {
            var o = this;
            var data = o.options.search_config;
            data.ids = ids;
            data.id = case_id;
            $.ajax({
                type: "GET",
                url: "/patient-manager/series",
                data: data,
                dataType: "JSON",
                success: function (data) {
                    if (typeof callback == "function") {
                        callback(data);
                    }
                },
            });
        },
        /*
         * Vetology.PatientSwissKnife._abortUnsupported
         *
         * @description	Disables the viewer, the browser is not supported;
         *
         * @return NULL
         *
         */
        _abortUnsupported: function () {
            $(".vetology_iv_canvas_container").remove();
            $(".interface_image_viewer")
                .removeClass("hide")
                .html(
                    '<div  style="margin-top: 20px;text-align: center;" class="alert alert-danger"><strong>Error!</strong> Unfortunately you are currently using an unsupported browser, these Vetology.net tools use modern technologies we recommend updating your browser to a newer version.<br><a href="https://caniuse.com/#feat=canvas" target="_blank">Img reference from caniuse.com click the image to learn more.<br><img src="/vetology_asset/images/canvas-support.png" style="max-width: 100%;"></a>'
                );
        },
        /*
         * Vetology.PatientSwissKnife._enableEventHandlers
         *
         * @description	Initializes the event handlers for the toolset
         *
         * @return NULL
         *
         */
        _enableEventHandlers: function () {
            var o = this;
            $(window).resize(function (e) {
                var height = $(window).height();
                var width = $(".width_sampler").width();
                $.each(o.options.cornerstone.elements, function (i, element) {
                    if (
                        o.options.search_config.compare_layout == 0 ||
                        $(element).closest(".interface_workarea").hasClass("vetology_iv_canvas_container")
                    ) {
                        $(element).css({ width: width, height: height - 130 });
                    } else {
                        $(element).css({ width: width * 2, height: height / 2 - 65 });
                    }
                    cornerstone.resize(element, true);
                });
                o._adjustRenderedStudiesHeight();
            });
            $("body").on("click", ".series_index_selector_span", function (e) {
                e.preventDefault();
                var series = $(this).closest(".series_loader_iv");
            });
            $("body").on("click", ".mail_ai_promo", function (e) {
                o.aiPromo(e);
            });
            $("body").on("click", ".series_loader_iv .series_activator", function (e) {
                e.preventDefault();
                var series = $(this).closest(".series_loader_iv");
                o._loadElementSeries(series);
            });
            $("body").on("click", ".series_loader_im .series_activator", function (e) {
                e.preventDefault();
                var el = $(this).closest(".series_loader_im");
                o._loadElementSeriesWithMatches(el);
            });
            $("body").on("change", ".species_tag", function (e) {
                var el = $(this);
                var species = o.options.patient.species.current;
                var newSpecies = el.val();
                if (species != newSpecies) {
                    o.options.update_search = true;
                    var save = false;
                    save = confirm(
                        "Would you like to save the change to the patient's demographics?\n\nClick cancel if you only like to use for this session but leave demographics unchanged."
                    );
                    o.options.patient.species.newSpecies = newSpecies;
                    if (save) {
                        o.options.patient.species.save = true;
                        o.options.patient.species.current = o.options.patient.species.newSpecies;
                    }
                    $(".search_apply").click();
                }
            });
            $("body").on("click", ".collapse_report_section", function (e) {
                var el = $(this);
                o._toggleReportSection(el);
            });
            $("body").on("click", ".pagination_stack_scroll a", function (e) {
                var el = $(this);
                if (!el.hasClass("prevent_action")) {
                    o._setStackIndex(el);
                }
            });
            $("body").on("click", ".pagination_stack_scroll_thumbs a", function (e) {
                if (!o.options.connected) {
                    return;
                }
                var index = $(this).data("index");
                var lis = $(".pagination_compare a");
                $.each(lis, function (i, el) {
                    if ($(el).data("index") == index) {
                        o._setStackIndex($(el));
                        if (o.options.matchedReportVisible) {
                            o._getStackImageReport(el);
                        }
                    }
                });
            });
            $("body").on("click", ".ai_back_to_report", function (e) {
                var el = $(this);
                o.switchMatcheReport(el);
            });
            $("body").on("click", ".manage_licenses", function (e) {
                $("body").addClass("license_manage").removeClass("image_viewer_active image_match_active");
                $(o.options.interfaces.global).addClass("hide");
                $("div.payment_options").addClass("hide");
                $(".license_data").removeClass("hide");
                $(".view-licenses-btn", ".enter-ai-license").addClass("hide");
                $(".add-new-licenses-btn", ".enter-ai-license").removeClass("hide");

                o._renderImageReport(-1, 0, false);
            });
            $("body").on("click", "#submit-ai-license-btn", function (e) {
                var license = $("#ai-license").val();
                $.ajax({
                    type: "POST",
                    url: "/patient-manager/register-ai-license",
                    data: { license_id: license },
                    dataType: "JSON",
                })
                    .done(function (data, textStatus, jqXHR) {
                        if (data.valid) {
                            $("body").Vetology(
                                "vetologyShowDialog",
                                "Saved AI License",
                                "Successfully saved AI license",
                                "success"
                            );
                            $(".manage_licenses").trigger("click");
                        } else {
                            var error = data.errors["message"];
                            $("body").Vetology("vetologyShowDialog", "Error saving license", error, "error");
                        }
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        $("body").Vetology(
                            "vetologyShowDialog",
                            "Saved AI License",
                            "Could not register AI license at this time.  Please call support",
                            "error"
                        );
                    });
            });
            $("body").on("click", ".patientswissknife_patient_demographics", function (e) {
                $(o.options.interfaces.global).addClass("hide");
                $(".patient_demographics").removeClass("hide");
            });
            $("body").on("submit", ".on_purchasing_old", function (e) {
                $("body").Vetology("vetologyLoadStart");
            });
            $("body").on("click", ".show_image_match", function (e) {
                o._hideMatchReport();
            });
            $("body").on("click", ".get_matched_report", function (e) {
                var el = $(this);
                $(".get_matched_report").find(".spin").removeClass("hide");
                if (!o.options.connected) {
                    $("body").Vetology(
                        "vetologyShowDialog",
                        "Attention:",
                        'The feature you are trying to use is reserved for logged in users.<br><p>Not a user? click <a href="/sign-up" target="_blank">here</a> to register or <a href="https://ai.vetology.net/vetradai/" target="_blank">here</a> to learn more about what AI can do for you.</p>',
                        "error"
                    );
                    return;
                }
                if (!el.hasClass("main_report_trigger")) {
                    el = $(".main_report_trigger");
                }
                o.options.matchedReportVisible = true;

                o._getStackImageReport(el);
            });
            $("body").on("click", ".set_stack_index", function (e) {
                var el = $(this);
                o._setStackIndex(el);
            });
            $("body").on("click", ".study_selector", function (e) {
                e.preventDefault();
                var el = $(this);
                el.removeClass("multi_studies");
            });
            $("body").on("click", ".add_license", function (e) {
                $("body").addClass("license_manage").removeClass("image_viewer_active image_match_active");
                $(".view-licenses-btn", ".enter-ai-license").removeClass("hide");
                $(".add-new-licenses-btn", ".enter-ai-license").addClass("hide");
                $("div.payment_options").removeClass("hide");
                $(".license_data").addClass("hide");
                o._renderImageReport(-1, 0, false);
            });
            $("body").on("change", ".study_selector", function (e) {
                var id = $(this).val();
                $(".rendered_studies > div").addClass("hide");
                $.each(o.options.cases, function (i, s) {
                    if (i == id) {
                        o.options.series = {
                            data: {
                                loaded: null,
                                all: s,
                            },
                            current: {
                                image_viewer: null,
                                ai: null,
                            },
                        };
                    }
                });
                $('.study_series_selector[data-series_id="' + id + '"]')
                    .find(".series_activator")
                    .first()
                    .click();
                $("body").Vetology("vetologyLoadStart", "Please wait while I load the study...", "I am almost there");
                const customEvent = new CustomEvent("study-selector-change-event", {
                    detail: {
                        originalEvent: e,
                    },
                });
                document.dispatchEvent(customEvent);
                setTimeout(function () {
                    $('.study_series_selector[data-series_id="' + id + '"]').removeClass("hide");
                    $("body").Vetology("vetologyLoadEnd");
                    o._adjustRenderedStudiesHeight();
                }, 2500);
            });
            $("body").on("click", ".search_apply", function (e) {
                e.preventDefault();
                var config = o.options.search_config;
                config.selected = true;
                config.species = o.options.patient.species;
                config.cid = o.options.id;
                $("body").Vetology("vetologyLoadStart");
                $.ajax({
                    type: "POST",
                    url: "/user/account",
                    data: config,
                    dataType: "JSON",
                    success: function (data) {
                        if (o.options.search_config.compare_layout == 1) {
                            $(
                                ".vetology_canvas_3_container, .vetology_canvas_2_container, .vetology_canvas_1_container"
                            )
                                .removeClass("col-xs-6")
                                .addClass("col-xs-12");
                            $(".rotate_layout").removeClass("layout_vertical").addClass("layout_horizontal");
                        } else {
                            $(
                                ".vetology_canvas_3_container, .vetology_canvas_2_container, .vetology_canvas_1_container"
                            )
                                .removeClass("col-xs-12")
                                .addClass("col-xs-6");
                            $(".rotate_layout").removeClass("layout_horizontal").addClass("layout_vertical");
                        }
                        if (o.options.update_search) {
                            $("body").Vetology("vetologyLoadEnd");
                            $("body").Vetology(
                                "vetologyShowDialog",
                                "Attention",
                                "When the Search Related or Threshold is changed, the page must be reloaded and the image match performed, to reflect the changed values.",
                                "info",
                                function () {
                                    var href = window.location.href;
                                    var imgMatchIdx = href.indexOf("perform-image-match");
                                    if (imgMatchIdx !== -1) {
                                        // remove current indexes
                                        href = href.substr(0, imgMatchIdx - 1);
                                    }
                                    var studyIdx = $("select.study_selector")[0].selectedIndex;
                                    var imgIdx = $("div.series_loader_im.active_series", ".study_series_selector").attr(
                                        "data-series"
                                    );
                                    href += "&perform-image-match=" + studyIdx + "," + imgIdx;
                                    location.href = href;
                                },
                                "Do not reload",
                                "Reload"
                            );
                        } else {
                            $(window).resize();
                            $("body").Vetology("vetologyLoadEnd");
                            if (typeof o.options.pagination.element != "undefined") {
                                o._updatePagination(
                                    o.options.pagination.element,
                                    o.options.pagination.pagination,
                                    o.options.pagination.index,
                                    o.options.pagination.stack,
                                    o.options.pagination.stackInfo
                                );
                            }
                        }
                    },
                });
            });
            $("body").on("click contextmenu", ".vetology_canvas", function (e) {
                var el = $(this);
                $(".vetology_canvas").removeClass("vetology_canvas_active");
                el.addClass("vetology_canvas_active");
            });
            $("body").on("click", ".plan_selector", function (e) {
                var el = $(this);
                o._triggerPurchaseOptions(el, 0);
            });
            $("body").on("click", ".radio_toggle a", function (e) {
                var el = $(this);
                var sel = el.data("title");
                var tog = el.data("toggle");
                var parent = el.closest(".input-group");
                parent.find("#" + tog).val(sel);
                parent.find("a").removeClass("active");
                el.addClass("active");
                switch (tog) {
                    case "search_rotated":
                        var rotated = sel == 1;
                        if (rotated != o.options.search_config.rotated) {
                            o.options.search_config.rotated = sel == 1;
                            o.options.update_search = true;
                        }
                        break;
                    case "image_format":
                        o.options.search_config.image_format = sel == 1 ? 1 : 0;
                        break;
                    case "compare_layout":
                        o.options.search_config.compare_layout = parseInt(sel, 10);
                        if ($.inArray(o.options.search_config.compare_layout, [0, 1]) == -1) {
                            o.options.search_config.compare_layout = 0;
                            $("#compare_layout").val(0);
                        }
                        break;
                    case "pagination_format":
                        o.options.search_config.pagination_format = parseInt(sel, 10);
                        if ($.inArray(o.options.search_config.pagination_format, [0, 1, 2]) == -1) {
                            o.options.search_config.pagination_format = 0;
                            $("#pagination_format").val(0);
                        }
                        break;
                }
            });
            $("body").on("click", ".make_license_primary", function (e) {
                var el = $(this);
                o._swapActiveLicense(el.data("id"));
            });
            $("body").on("change", ".plan_selection", function (e) {
                var el = $(this);
                o._triggerPurchaseOptions(el, el.val());
            });
            $("body").on("click", ".rotate_layout", function (e) {
                var el = $(this);
                if (el.hasClass("layout_horizontal")) {
                    $(".rotate_layout").removeClass("layout_horizontal").addClass("layout_vertical");
                    $('[data-toggle="compare_layout"][data-title="1"]').removeClass("active");
                    $('[data-toggle="compare_layout"][data-title="0"]').addClass("active");
                    $("#compare_layout").val(0);
                    o.options.search_config.compare_layout = 0;
                } else {
                    $(".rotate_layout").removeClass("layout_vertical").addClass("layout_horizontal");
                    $('[data-toggle="compare_layout"][data-title="0"]').removeClass("active");
                    $('[data-toggle="compare_layout"][data-title="1"]').addClass("active");
                    $("#compare_layout").val(1);
                    o.options.search_config.compare_layout = 1;
                }
                $("#compare_layout").change();
                $(".search_apply").click();
            });
            o._initToolManager(o);
            o._initCornerstone(o);
            o._imageViewerHandlers(o);
            o._diagnosysHandlers(o);
        },
        /*
         * Vetology.PatientSwissKnife._hideMatchReport
         *
         * @description	Hides the section of the report that matches
         *
         * @return NULL
         *
         */
        _hideMatchReport: function () {
            var o = this;
            o.options.matchedReportVisible = false;
            $(".vetology_canvas_3_container").addClass("hide");
            $(".vetology_canvas_2_container").fadeIn("slow");
            $(".show_image_match").addClass("hide");
            $(".get_matched_report").show();
        },
        /*
         * Vetology.PatientSwissKnife._toggleReportSection
         *
         * @description	Displays or hides the report section
         *
         * @return NULL
         *
         */
        _toggleReportSection: function (el) {
            el.toggleClass("report_close");
            $(".vetology_iv_purchased_report").toggleClass("report_close").toggleClass("col-xs-6");
            $(".vetology_iv_canvas_container").toggleClass("col-xs-12").toggleClass("col-xs-6");
            $(window).resize();
        },
        /*
         * Vetology.PatientSwissKnife._setStackIndex
         *
         * @description	Loads events for the tools to enable or disable depending on the device used and device/button/gesture selected
         *
         * @return NULL
         *
         */
        _setStackIndex: function (el) {
            var o = this;
            var is_compare = el.closest(".interface_workarea").find(".vetology_canvas").hasClass("vetology_canvas_2");
            var element = el.closest(".interface_workarea").find(".vetology_canvas")[0];
            if (typeof element == "undefined") {
                var element = $(".vetology_canvas_2")[0];
                is_compare = true;
            }
            var pagination = el.closest(".interface_workarea").find(".pagination");
            var indexUl = 0;
            var direction = el.data("direction");
            switch (direction) {
                case "left":
                case "right":
                    var stack = cornerstoneTools.getElementToolStateManager(element);
                    var index = stack.toolState.stack.data[0].currentImageIdIndex;
                    var stackSize = stack.toolState.stack.data[0].imageIds.length - 1;
                    var newIndex = index;
                    if (el.data("direction") == "left") {
                        newIndex--;
                    } else {
                        newIndex++;
                    }
                    if (newIndex < 0) {
                        newIndex = stackSize;
                    }
                    if (newIndex > stackSize) {
                        newIndex = 0;
                    }
                    cornerstoneTools.scrollToIndex(element, newIndex);
                    var pagination_stack_scroll = el.closest("div").find(".pagination_stack_scroll");
                    pagination_stack_scroll.find("li").removeClass("active");
                    pagination_stack_scroll
                        .find('a[data-index="' + newIndex + '"]')
                        .closest("li")
                        .addClass("active");
                    indexUl = newIndex;
                    break;
                case "up":
                case "down":
                    /*First find in which workarea we are, viewer or image comparison*/
                    var items = $(".study_series_selector").not(".hide").find(".interface_manager").not(".hide");
                    var currentIndex;
                    $.each(items, function (i, item) {
                        if ($(item).hasClass("active_series")) {
                            currentIndex = i;
                        }
                    });
                    var len = items.length - 1;
                    if (direction == "up") {
                        currentIndex--;
                    } else {
                        currentIndex++;
                    }
                    if (currentIndex < 0) {
                        currentIndex = len;
                    } else if (currentIndex > len) {
                        currentIndex = 0;
                    }
                    $.each(items, function (i, item) {
                        if (currentIndex == i) {
                            $(item).find(".series_activator").click();
                            return false;
                        }
                    });
                    break;
                default:
                    el.closest("ul").find("li").removeClass("active").removeAttr("style");
                    el.closest("li").addClass("active");
                    indexUl = el.data("index");
                    cornerstoneTools.scrollToIndex(element, el.data("index"));
                    el.closest("ul").find(".removable").remove();
                    break;
            }
        },
        /*
         * Vetology.PatientSwissKnife._getReportClass
         *
         * @description	Sets the class name for the reports
         *
         * @return NULL
         *
         */
        _setReportClass: function () {
            var o = this;
            var element = $(".vetology_canvas_2")[0];
            if ($(element).hasClass("is_cornerstone_enabled")) {
                var stack = cornerstoneTools.getElementToolStateManager(element);
                if (typeof stack.toolState.stack == "undefined") {
                    return;
                }
                var index = stack.toolState.stack.data[0].currentImageIdIndex;
                var image = stack.toolState.stack.data[0].imageTarget[index];
                var percentage = stack.toolState.stack.data[0].imageData[index];
                var information = stack.toolState.stack.data[0].imageDataSet[index];
                if (typeof information != "undefined" && information.has_report) {
                    $(".vetology-view.has-report").css("display", "inline-block");
                } else {
                    $(".vetology-view.has-report").css("display", "none");
                }

                o._setReportLockedStatus(o, information);
            }
        },
        /**
         * Vetology.PatientSwissKnife._setReportLockedStatus
         *
         * @description sets the locked/unlocked status on the report button
         * @param o
         * @param information
         * @private
         */
        _setReportLockedStatus: function (o, information) {
            if (!o.options.pagination || !o.options.pagination.stack || !o.options.pagination.stack.searched_config) {
                $(".get_matched_report").addClass("is_locked").removeClass("is_unlocked");
                $(".search-keyword-btn").addClass("is_locked").removeClass("is_unlocked");
            } else {
                let sourceCaseID = o.options.pagination.stack.searched_config.case_id,
                    sourceImageID = o.options.pagination.stack.searched_config.image_id,
                    targetCaseID = information.case_id,
                    targetImageID = information.image_id;

                // check if locked status is cached
                if (
                    o.options.pagination.stack.lockStatus &&
                    o.options.pagination.stack.lockStatus.hasOwnProperty(
                        sourceImageID + "." + targetCaseID + "." + targetImageID
                    )
                ) {
                    let lockStatus =
                        o.options.pagination.stack.lockStatus[sourceImageID + "." + targetCaseID + "." + targetImageID];
                    if (lockStatus) {
                        $(".get_matched_report").removeClass("is_locked").addClass("is_unlocked");
                        $(".search-keyword-btn").removeClass("is_locked").addClass("is_unlocked");
                    } else {
                        $(".get_matched_report").addClass("is_locked").removeClass("is_unlocked");
                        $(".search-keyword-btn").addClass("is_locked").removeClass("is_unlocked");
                    }
                    return;
                }

                // check for valid license
                let data = {
                    source: {
                        case_id: sourceCaseID,
                        image_id: sourceImageID,
                    },
                    target: {
                        case_id: targetCaseID,
                        image_id: targetImageID,
                    },
                };
                $.ajax({
                    type: "GET",
                    url: "/patient-manager/validate-ai-license",
                    data: data,
                    _data: data,
                    dataType: "JSON",
                })
                    .done(function (data, textStatus, jqXHR) {
                        // cache results so we don't need to make this call again for this case/image
                        let options = $("body").PatientSwissKnife("instance").options;
                        if (typeof options.pagination.stack.lockStatus == "undefined") {
                            options.pagination.stack.lockStatus = {};
                        }
                        let key =
                            this._data.source.image_id +
                            "." +
                            this._data.target.case_id +
                            "." +
                            this._data.target.image_id;
                        options.pagination.stack.lockStatus[key] = data.validAiLicense;

                        if (data.validAiLicense) {
                            $(".get_matched_report").removeClass("is_locked").addClass("is_unlocked");
                            $(".search-keyword-btn").removeClass("is_locked").addClass("is_unlocked");
                        } else {
                            $(".get_matched_report").addClass("is_locked").removeClass("is_unlocked");
                            $(".search-keyword-btn").addClass("is_locked").removeClass("is_unlocked");
                        }
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        $(".get_matched_report").addClass("is_locked").removeClass("is_unlocked");
                        $(".search-keyword-btn").addClass("is_locked").removeClass("is_unlocked");
                    });
            }
        },
        _renderPopUp: function (url) {
            var o = this;
            var win = window.open(url, "_blank");
            if (win) {
                if (/chrome/.test(navigator.userAgent.toLowerCase())) {
                    setTimeout(function () {
                        o._isPopupBlocked(win);
                    }, 200);
                } else {
                    win.onload = function () {
                        o._isPopupBlocked(win);
                    };
                }
            } else {
                o._renderPopupError();
            }
        },
        _isPopupBlocked: function (win) {
            var o = this;
            if (win.innerHeight > 0 == false) {
                o._renderPopupError();
            }
            return false;
        },
        _renderPopupError: function (win) {
            var b = this._getBrowser();
            $(".popup_blocked")
                .addClass("popup_" + b[0])
                .removeClass("hide");
        },
        _closePopupError: function (win) {
            $(".popup_blocked").addClass("hide");
        },
        _getBrowserSearchString: function (data) {
            for (var i = 0; i < data.length; i++) {
                var dataString = data[i].string;
                this.versionSearchString = data[i].subString;
                if (dataString.indexOf(data[i].subString) !== -1) {
                    return data[i].identity;
                }
            }
        },
        _getBrowserSearchVersion: function (dataString) {
            var index = dataString.indexOf(this.versionSearchString);
            if (index === -1) {
                return;
            }
            var rv = dataString.indexOf("rv:");
            if (this.versionSearchString === "Trident" && rv !== -1) {
                return parseFloat(dataString.substring(rv + 3));
            } else {
                return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
            }
        },
        _getBrowser: function () {
            var o = this;
            var browsers_list = [
                { string: navigator.userAgent, subString: "Edge", identity: "edge" },
                { string: navigator.userAgent, subString: "MSIE", identity: "msie" },
                { string: navigator.userAgent, subString: "Trident", identity: "Explorer" },
                { string: navigator.userAgent, subString: "Firefox", identity: "firefox" },
                { string: navigator.userAgent, subString: "Opera", identity: "opera" },
                { string: navigator.userAgent, subString: "OPR", identity: "opera" },
                { string: navigator.userAgent, subString: "Chrome", identity: "chrome" },
                { string: navigator.userAgent, subString: "Safari", identity: "safari" },
            ];
            var b = o._getBrowserSearchString(browsers_list) || "Other";
            var version =
                o._getBrowserSearchVersion(navigator.userAgent) ||
                this._getBrowserSearchVersion(navigator.appVersion) ||
                "Unknown";
            return [b, version];
        },
        /*
         * Vetology.PatientSwissKnife._getStackImageReport
         *
         * @description	Loads events for the tools to enable or disable depending on the device used and device/button/gesture selected
         *
         * @return NULL
         *
         */
        _getStackImageReport: function (el) {
            var o = this;
            var element = $(".vetology_canvas_2")[0];
            var stack = cornerstoneTools.getElementToolStateManager(element);
            if (stack && stack.toolState && stack.toolState.stack) {
                if (stack.toolState.stack.data && stack.toolState.stack.data[0].has_matches) {
                    /*we have a match*/
                    var index = stack.toolState.stack.data[0].currentImageIdIndex;
                    var target_data = stack.toolState.stack.data[0].imageDataSet[index];
                    element = $(".vetology_canvas_1")[0];
                    stack = cornerstoneTools.getElementToolStateManager(element);
                    index = stack.toolState.stack.data[0].currentImageIdIndex;
                    var source_data = stack.toolState.stack.data[0].imageDataSet[index];
                    o._renderImageReport(target_data.link, source_data.link, target_data.level, false, true);
                } else {
                    o._hideMatchReport();
                    alert(
                        "We are sorry but the image you have selected indicates we have not found any matching report."
                    );
                }
            }
        },
        /*
         * Vetology.PatientSwissKnife._triggerPurchaseOptions
         *
         * @description	GEts settings for purchasing a plan.
         *
         * @return NULL
         *
         */
        _triggerPurchaseOptions: function (el, p) {
            var o = this;
            var data = {
                plan: el.data("plan"),
                blocks: el.data("blocks"),
                report: el.data("report"),
                target: el.data("target"),
                rate: el.data("rate"),
                cid: o.options.id,
            };
            $("body").Vetology(
                "vetologyLoadStart",
                "<strong>Please wait:</strong> We are now redirecting you to PayPal to complete the payment"
            );
            $.ajax({
                type: "GET",
                url: "/patient-manager/get-report-plan",
                dataType: "JSON",
                data: data,
                success: function (data) {
                    $(".payment_processing").html(data.form);
                    $(".on_purchasing").submit();
                },
            });
        },
        /*
         * Vetology.PatientSwissKnife._activatePurchaseCancel
         *
         * @description	Enables purchase canceled.
         *
         * @return NULL
         *
         */
        _activatePurchaseCancel: function () {
            var o = this;
            o._renderImageReport(-1, 0, 0, true);
        },
        /*
         * Vetology.PatientSwissKnife._swapActiveLicense
         *
         * @description	Enables a license on the logged in user.
         *
         * @return NULL
         *
         */
        _swapActiveLicense: function (license) {
            var o = this;
            $("body").Vetology("vetologyLoadStart");
            $.ajax({
                type: "GET",
                url: "/license/details?primary=" + license,
                dataType: "JSON",
                success: function (data) {
                    $(".licenses_info").html(data.html);
                    $("body").Vetology("vetologyLoadEnd");
                },
            });
        },
        /*
         * Vetology.PatientSwissKnife._activatePurchaseCheckPremiumPlans
         *
         * @description	Enables purchase checking on premium plans.
         *
         * @return NULL
         *
         */
        _activatePurchaseCheckPremiumPlans: function (transaction) {
            var o = this;
            var messages = [
                "Please wait while we collect your payment details...",
                "We are still collecting your payment details, please wait...",
                "This process can take up to 5 minutes...",
            ];
            var m = 0;
            var m2 = "<strong>Attention:</strong> We are collecting your payment details<br>";
            $("body").Vetology("vetologyLoadStart", m2 + messages[m], m2 + messages[m]);
            m++;
            var intervalLicense = setInterval(function () {
                $.ajax({
                    type: "GET",
                    url: "/license/details?tx=" + transaction,
                    dataType: "JSON",
                    success: function (data) {
                        $("body").Vetology("vetologyLoadEnd");
                        m++;
                        if (m > 2) {
                            m = 0;
                        }
                        $("body").Vetology("vetologyLoadStart", m2 + messages[m], m2 + messages[m]);
                        if (data.hasLicense && data.premium) {
                            clearInterval(intervalLicense);
                            $("body").Vetology("vetologyLoadEnd");
                            $("body").Vetology(
                                "vetologyLoadStart",
                                "<strong>Success:</strong> Your report is active and you may submit the details for review now.<br>Redirecting you so you can complete the submit process, please wait...."
                            );
                            location.replace(
                                "https://" +
                                    window.location.hostname +
                                    "/worklist/clinic?case_id=" +
                                    data.case_id +
                                    "&globalSearch=5&DateRange=1988-11-24::2018-12-24&submit=true"
                            );
                        }
                    },
                });
            }, 5000);
        },
        /*
         * Vetology.PatientSwissKnife._activatePurchaseCancel
         *
         * @description	Enables purchase canceled.
         *
         * @return NULL
         *
         */
        _activatePurchaseCancelPremiumPlans: function () {
            var o = this;
        },
        /*
         * Vetology.PatientSwissKnife._activatePurchaseCheck
         *
         * @description	Enables purchase checking.
         *
         * @return NULL
         *
         */
        _activatePurchaseCheck: function (transaction) {
            var o = this;
            $(o.options.interfaces.global).addClass("hide");
            $(".license_data").removeClass("hide");
            $(".processing_payment_info").removeClass("hide");
            var messages = [
                "Please wait while we collect your payment details...",
                "We are still collecting your payment details, please wait...",
                "This process can take up to 5 minutes...",
            ];
            var m = 0;
            $(".payment_info_progress").html(messages[m]);
            m++;
            var intervalLicense = setInterval(function () {
                $.ajax({
                    type: "GET",
                    url: "/license/details?tx=" + transaction,
                    dataType: "JSON",
                    success: function (data) {
                        if (data.this && data.that) {
                            $.each(o.options.series.data.all, function (i, s) {
                                $.each(s.dicoms, function (t, d) {
                                    if (d.id === data.this) {
                                        o.options.patient.series_match_preload = i;
                                        $.each(s.stack_compare.imageIds, function (t, m) {
                                            if (m === "vetology:" + data.that) {
                                                o.options.patient.image_match_preload = t;
                                            }
                                        });
                                    }
                                });
                            });
                        }
                        $(".licenses_info").html(data.html);
                        if (data.hasLicense) {
                            clearInterval(intervalLicense);
                            if (typeof o.options.patient.series_match_preload !== "undefined") {
                                $(".processing_payment_info")
                                    .removeClass("alert-danger")
                                    .addClass("alert-success")
                                    .html(
                                        '<strong>Success:</strong> Your license is active an you may start using it now.<br>See the details of your license below, highlighted in blue.<br><br>You will be redirected in <span class="timer_report">10</span> seconds to the report you were trying to open.'
                                    );
                                var rep_ready = setInterval(function () {
                                    var s = parseInt($(".timer_report").html());
                                    s--;
                                    if (s === -1) {
                                        clearInterval(rep_ready);
                                        $(".patientswissknife_image_diagnosys").click();
                                    } else {
                                        $(".timer_report").html(s);
                                    }
                                }, 1000);
                            } else {
                                $(".processing_payment_info")
                                    .removeClass("alert-danger")
                                    .addClass("alert-success")
                                    .html(
                                        "<strong>Success:</strong> Your license is active an you may start using it now.<br>See the details of your license below, highlighted in blue."
                                    );
                            }
                        } else {
                            $(".payment_info_progress").html(messages[m]);
                            m++;
                            if (m > 1) {
                                m = 0;
                            }
                        }
                    },
                });
            }, 5000);
        },
        /*
         * Vetology.PatientSwissKnife._triggerPayment
         *
         * @description	Enables payment processing.
         *
         * @return NULL
         *
         */
        _triggerPayment: function (plans, showCanelError) {
            var o = this;
            $(o.options.interfaces.global).addClass("hide");
            $(".payment_processor").removeClass("hide");
            if (o.options.report_attempt.th !== false) {
                $(".add-new-licenses-btn", ".enter-ai-license").addClass("hide");
                $(".view-licenses-btn", ".enter-ai-license").removeClass("hide");
            }
            if (showCanelError) {
                $(".payment_processor").find(".cancelError").removeClass("hide");
            } else {
                $(".payment_processor").find(".cancelError").addClass("hide");
            }
            $(".payment_processor").find(".successMessage").addClass("hide");
            $(".payment_options").html(plans);
            $(".help_area").tooltip();
            $(".payment_processing").html("");
        },
        /*
         * Vetology.PatientSwissKnife._renderImageReport
         *
         * @description	Renders the selected image report
         *
         * @return NULL
         *
         */
        _renderImageReport: function (target, src, th, withCancelError, dataLoading, stack, index) {
            var o = this;
            o.options.report_attempt = {
                src: src,
                th: th,
                target: target,
            };
            if (target != -1 || src != 0) {
                //Checking if there is a valid license
                var options = $("body").PatientSwissKnife("instance").options;
                var element = $(".vetology_canvas_2")[0];

                var stack = cornerstoneTools.getElementToolStateManager(element);

                if (typeof stack.toolState.stack === "undefined") {
                    return;
                }

                var index = stack.toolState.stack.data[0].currentImageIdIndex;
                var information = stack.toolState.stack.data[0].imageDataSet[index];
                var sourceImageID = o.options.pagination.stack.searched_config.image_id,
                    targetCaseID = information.case_id,
                    targetImageID = information.image_id;
                var key = sourceImageID + "." + targetCaseID + "." + targetImageID;
            }
            $.ajax({
                type: "GET",
                url: "/patient-manager/get-report?source_id=" + src + "&th=" + th + "&target_id=" + target,
                dataType: "JSON",
                success: function (data) {
                    if (data.active) {
                        o.options.reports[target] = data.report;
                        if (o.options.matchedReportVisible) {
                            o._getReportCaseMatch(data.report);
                        }
                        o._setReportClass();
                    } else {
                        $(".get_matched_report").find(".spin").addClass("hide");
                        o._triggerPayment(data.plans, withCancelError);
                    }
                },
            });
        },
        /*
         * Vetology.PatientSwissKnife._getReportCaseMatch
         *
         * @description	Renders the selected image report
         *
         * @return NULL
         *
         */
        _getReportCaseMatch: function (report) {
            var o = this;
            o._clearReportMatch();
            $.ajax({
                type: "GET",
                url: "/case-match-report?id=" + report,
                dataType: "JSON",
                success: function (data) {
                    var icon_specie =
                        data.case_match_data.patient.species.icon == ""
                            ? "Demographics"
                            : "vetology-" + data.case_match_data.patient.species.icon;

                    $(".vetology-specie-icon").addClass(icon_specie);

                    if (data.report_match_data !== null) {
                        $(".purchased_report_match").html(data.report_match_data);
                    }

                    if (data.report_patient_match_data !== null) {
                        $(".purchase_patient_compaprison_match").html(data.report_patient_match_data);
                    }

                    if (data.report_history_patient_match_data !== null) {
                        $(".purchase_patient_history_match").html(data.report_history_patient_match_data);
                    }
                    // hide the panel of matching images
                    $(".vetology_canvas_2_container").fadeOut("slow");
                    // show the matching report panel
                    $(".vetology_canvas_3_container").removeClass("hide");
                    var number = $(".match_thumb.active").find(".badge_index").text();
                    $(".match-report-number").append(number);
                    // hide and show this button clickeable
                    $(".show_image_match").removeClass("hide");

                    $(".get_matched_report").find(".spin").addClass("hide");
                    $(".get_matched_report").hide();
                },
                error: function (data) {
                    $(".get_matched_report").find(".spin").addClass("hide");
                    $("body").Vetology("vetologyShowDialog", "Error:", data.responseText, "error");
                },
            });
        },
        /*
         * Vetology.PatientSwissKnife._clearReportMatch
         *
         * @description	Clear report match selected
         *
         * @return NULL
         *
         */
        _clearReportMatch: function () {
            $(".purchased_report_match").html("");
            $(".purchase_patient_compaprison_match").html("");
            $(".purchase_patient_history_match").html("");
            $(".match-report-number").text("");
        },
        /*
         * Vetology.PatientSwissKnife._initToolManager
         *
         * @description	Loads events for the tools to enable or disable depending on the device used and device/button/gesture selected
         *
         * @return NULL
         *
         */
        _initToolManager: function (o) {
            $("body").on("click", ".toolset_toggle", function (e) {
                var el = $(this);
                $(".vetology_canvas").removeClass("vetology_canvas_active");
                el.addClass("vetology_canvas_active");
                var toggle = el.data("toggle");
                if (toggle == "down") {
                    $(".interface_tools").addClass("touch_active");
                } else {
                    $(".interface_tools").removeClass("touch_active");
                }
            });
            $("body").on("click", ".tool_touch_button_selector .tool_button", function (e) {
                var el = $(this);
                var toolManager = el.closest(".tool_touch_button_selector");
                $(".interface_tools").addClass("touch_active");
                toolManager.find(".tool_button").removeClass("active");
                el.addClass("active");
                var action = el.data("action");
                var tool = el.data("tool");
                toolManager.data("action", action);
                /*
						enable disable buttons based on the action selected
					*/
                toolManager.find(".tool_buttons button").addClass("hide").removeClass("active");
                if (tool != -1) {
                    toolManager.find('.tool_buttons button[data-tool="' + tool + '"]').addClass("active");
                }
                switch (action) {
                    case 1:
                    case 2:
                    case 4:
                        toolManager
                            .find(".tool_buttons .tools_1, .tool_buttons .tools_2, .tool_buttons .tools_4")
                            .removeClass("hide");
                        break;
                    case 6:
                        toolManager.find(".tool_buttons .tools_6").removeClass("hide");
                        break;
                    case 7:
                        toolManager.find(".tool_buttons .tools_7").removeClass("hide");
                        break;
                    case 8:
                        toolManager.find(".tool_buttons .tools_8").removeClass("hide");
                        break;
                    case 9:
                        toolManager.find(".tool_buttons .tools_9").removeClass("hide");
                        break;
                    case 10:
                        toolManager.find(".tool_buttons .tools_10").removeClass("hide");
                        break;
                }
                toolManager.find(".tool_buttons button.tool_global").removeClass("hide");
            });
        },
        /*
         * Vetology.PatientSwissKnife._loadElementSeries
         *
         * @description	Loads a particular series into a given element
         *
         * @return NULL
         *
         */
        _loadElementSeries: function (el) {
            var o = this;
            // check if there's a multiframe playing
            var $playBtn = $("button[data-tool='play']");
            if ($playBtn.find("span").hasClass("vetology-stop")) {
                $playBtn.data("tool", "stop");
                o._enableCornerstoneTool(o, $playBtn);
            }

            var parent = el.closest(".series_loader");
            var main_parent = parent.closest(".vetology_series_nav");
            var active = parent.hasClass("active_series");
            main_parent.find(".series_loader_iv").removeClass("active_series");
            parent.addClass("active_series");
            if (!active || parent.parent().hasClass("hide")) {
                var series = el.data("series");
                if ($(o.options.interfaces.image_viewer.main).hasClass("hide")) {
                    /*Load image viewer*/
                    $(".patientswissknife_image_viewer").click();
                }
                var element = $(".interface_image_viewer .vetology_canvas")[0];
                $(element).closest(".interface_workarea").addClass("loading_workarea");
                series = o.options.series.data.all[series];

                // load progressbar data
                $("body").VetologyCache("unsetDownloadQueue");
                for (const [key, value] of Object.entries(o.options.series.data.all)) {
                    $.each(value.stack.imageIds, function (i, crypt) {
                        if (typeof o.options.load_manager.images[crypt] == "undefined") {
                            o.options.load_manager.images[crypt] = {
                                index: i,
                                series: series.cid,
                                series_index: key,
                                loaded: 0,
                                cached: 0,
                                percentComplete: 0,
                                total: 0,
                                is_completed: false,
                                is_im: false,
                            };
                        }
                    });
                }

                const vrContainer = document.querySelectorAll(".container-virtual-report");
                vrContainer.forEach((elem) => {
                    elem.classList.add("hide");
                });
                const reportBtn = document.querySelector("#virtual-report-available");
                if (reportBtn) {
                    reportBtn.parentNode.classList.add("disabled");
                    reportBtn.classList.add("vr-disabled");
                    if (typeof series.evalReportUrl != "undefined" && series.evalReportUrl != "") {
                        // find the virtual report link and set the href
                        vrContainer.forEach((elem) => {
                            if (elem.dataset.case_url != "") {
                                reportBtn.parentNode.classList.remove("disabled");
                                reportBtn.classList.remove("vr-disabled");
                                if (elem.dataset.case_url == series.cid) {
                                    elem.classList.remove("hide");
                                }
                            }
                        });
                        const virtualReportLink = document.querySelector(".container-virtual-report a");
                        if (virtualReportLink) {
                            virtualReportLink.href = series.evalReportUrl;
                        }
                    }
                }
                o._cornerStoneLoadSeries(
                    series,
                    element,
                    function (element, image) {
                        cornerstone.displayImage(element, image);
                        const viewport = cornerstone.getViewport(element);
                        viewport.hflip = false;
                        viewport.rotation = 0;
                        if (
                            typeof series.dicoms == "object" &&
                            typeof series.dicoms[series.index] == "object" &&
                            (series.dicoms[series.index].transformation.rotation != 0 ||
                                series.dicoms[series.index].transformation.flip)
                        ) {
                            if (
                                series.dicoms[series.index].transformation.rotation != 0 &&
                                o.correctedImagesSwitch.classList.contains("on")
                            ) {
                                viewport.rotation = series.dicoms[series.index].transformation.rotation;
                            }
                            if (series.dicoms[series.index].transformation.flip) {
                                viewport.hflip = true;
                            }
                        }
                        cornerstone.setViewport(element, viewport);

                        setTimeout(function () {
                            $(element).closest(".interface_workarea").removeClass("loading_workarea");
                        }, 300);
                        cornerstoneTools.addStackStateManager(element, ["stack"]);
                        cornerstoneTools.addToolState(element, "stack", series.stack);
                        var pagination = $(element).closest(".interface_workarea").find(".pagination_stack_scroll");
                        if (pagination.length > 0) {
                            o._updatePagination(element, pagination, 0, series.stack, series.stack.imageDataSet);
                        }
                    },
                    false,
                    false
                );
            }
        },
        /*
         * Vetology.PatientSwissKnife.switchMatcheReport
         *
         * @description	Loads a particular series into a given element and the image matches
         *
         * @return NULL
         *
         */
        switchMatcheReport: function (el) {
            var o = this;
            /*.closest(".series_loader_im")*/
            if (!$(".report_view").hasClass("hide")) {
                /*The viewer is not visible*/
                el.html("Back to report");
                $(o.options.interfaces.global).addClass("hide");
                $(".row.interface_image_viewer.interface_manager").removeClass("hide");
            } else {
                /*The report is not visible*/
                el.html("View Lion Doe images");
                $(o.options.interfaces.global).addClass("hide");
                $(".row.report_view.interface_manager").removeClass("hide");
            }
            $(window).resize();
        },
        /*
         * Vetology.PatientSwissKnife._loadElementSeriesWithMatches
         *
         * @description	Loads a particular series into a given element and the image matches
         *
         * @return NULL
         *
         */
        _loadElementSeriesWithMatches: function (el) {
            var o = this;
            var series = el.data("series");
            var parent = el.closest(".series_loader");
            var main_parent = parent.closest(".vetology_series_nav");
            var active = parent.hasClass("active_series");
            main_parent.find(".series_loader_im").removeClass("active_series");
            if (!active) {
                series = o.options.series.data.all[series];
                var iid = el.data("image");
                if ($(o.options.interfaces.image_diagnosys.main).hasClass("hide")) {
                    /*Load image viewer*/
                    $(".patientswissknife_image_diagnosys").click();
                }
                var element = $(".interface_image_diagnosys .vetology_canvas_1")[0];
                var element_compare = $(".interface_image_diagnosys .vetology_canvas_2")[0];
                var compareI = setInterval(function () {
                    $(element_compare)
                        .closest(".interface_workarea")
                        .addClass("loading_workarea")
                        .addClass("without_matches")
                        .removeClass("with_multiple_matches");
                }, 50);
                var interfaceI = setInterval(function () {
                    $(element).closest(".interface_workarea").addClass("loading_workarea");
                }, 50);
                o._cornerStoneLoadSeries(
                    series,
                    element,
                    function (element, image) {
                        clearInterval(interfaceI);
                        cornerstone.displayImage(element, image);
                        setTimeout(function () {
                            $(element).closest(".interface_workarea").removeClass("loading_workarea");
                        }, 300);
                        cornerstoneTools.addStackStateManager(element, ["stack"]);
                        cornerstoneTools.addToolState(element, "stack", series.stack);
                        parent.addClass("active_series");
                    },
                    false,
                    true
                );
                o._cornerStoneLoadSeries(
                    series,
                    element_compare,
                    function (element, image) {
                        clearInterval(compareI);
                        compareI = false;
                        if (series.stack_compare.has_matches) {
                            $(element_compare).closest(".interface_workarea").removeClass("without_matches");
                        }
                        if (series.stack_compare.has_matches && series.stack_compare.imageIds.length > 1) {
                            $(element_compare).closest(".interface_workarea").addClass("with_multiple_matches");
                        }
                        if (image) {
                            cornerstone.displayImage(element, image);
                        }
                        setTimeout(function () {
                            $(element_compare).closest(".interface_workarea").removeClass("loading_workarea");
                        }, 300);
                        cornerstoneTools.addStackStateManager(element, ["stack"]);
                        cornerstoneTools.addToolState(element, "stack", series.stack_compare);
                        var pagination = $(element).closest(".interface_workarea").find(".pagination_stack_scroll");
                        if (pagination.length > 0) {
                            o._updatePagination(
                                element,
                                pagination,
                                0,
                                series.stack_compare,
                                series.stack_compare.imageDataSet
                            );
                            if (o.options.matchedReportVisible) {
                                /**
                                 * Load report matches
                                 */
                                o._getStackImageReport(el);
                            }
                        }
                    },
                    true,
                    false
                );
            } else {
                parent.addClass("active_series");
            }
        },
        /*
         * Vetology.PatientSwissKnife._resetAllCornerstoneTools
         *
         * @description	Disables the cornerstone tools then enables the ones passed;
         *
         * @return NULL
         *
         */
        _resetAllCornerstoneTools: function (o, element) {
            $.each(
                [
                    "probe",
                    "length",
                    "ellipticalRoi",
                    "rectangleRoi",
                    "simpleAngle",
                    "angle",
                    "highlight",
                    "freehand",
                    "zoom",
                    "wwwc",
                    "pan",
                    "stackScroll",
                    "brush",
                    "magnify" /*"crop"*/,
                ],
                function (i, tool) {
                    cornerstoneTools[tool].deactivate(element, 1);
                    cornerstoneTools[tool].deactivate(element, 2);
                    cornerstoneTools[tool].deactivate(element, 4);
                }
            );
            cornerstoneTools.stackScrollWheel.deactivate(element);
            cornerstoneTools.zoomWheel.deactivate(element);
            if (Modernizr.touchevents) {
                cornerstoneTools.zoomTouchPinch.deactivate(element);
                cornerstoneTools.wwwcTouchDrag.deactivate(element);
                cornerstoneTools.panMultiTouch.deactivate(element);
                cornerstoneTools.magnifyTouchDrag.deactivate(element);
                cornerstoneTools.lengthTouch.deactivate(element);
            }
            $(".tool_button .tool_active span").attr("class", "");
            var tools = [];
            var activeButtons = [];
            $.each(o.options.cornerstone.tools.active, function (button, tool) {
                if ($.inArray(tool, tools) > -1 || $.inArray(button, activeButtons) > -1) {
                    return true;
                }
                activeButtons.push(button);
                tools.push(tool);
                switch (button) {
                    case "leftMouse":
                        if (typeof cornerstoneTools[tool] != "undefined") {
                            o._updateToolIcon("leftMouse", tool);
                            cornerstoneTools[tool].activate(element, 1);
                        }
                        break;
                    case "centerMouse":
                        if (typeof cornerstoneTools[tool] != "undefined") {
                            o._updateToolIcon("centerMouse", tool);
                            cornerstoneTools[tool].activate(element, 2);
                        }
                        break;
                    case "rightMouse":
                        if (typeof cornerstoneTools[tool] != "undefined") {
                            o._updateToolIcon("rightMouse", tool);
                            cornerstoneTools[tool].activate(element, 4);
                        }
                        break;
                    case "scrollMouse":
                        if (typeof cornerstoneTools[tool] != "undefined") {
                            o._updateToolIcon("scrollMouse", tool);
                            cornerstoneTools[tool].activate(element);
                        }
                        break;
                    case "touch":
                    case "multiTouch":
                    case "pinch":
                    case "touchAndDrag":
                        if (Modernizr.touchevents) {
                            if (typeof cornerstoneTools[tool] != "undefined") {
                                o._updateToolIcon(button, tool);
                                cornerstoneTools[tool].activate(element);
                            }
                        }
                        break;
                }
            });
            cornerstone.updateImage(element, true);
        },
        /*
         * Vetology.PatientSwissKnife._updateToolIcon
         *
         * @description	Updates the interface tool icon;
         *
         * @return NULL
         *
         */
        _updateToolIcon: function (button, tool) {
            var className = "vetology-";
            var html = "";
            switch (tool) {
                case "wwwc":
                case "wwwcTouchDrag":
                    className += "ww-wc";
                    break;
                case "zoom":
                case "zoomWheel":
                case "zoomTouchPinch":
                case "zoomTouchDrag":
                    className += "zoom";
                    break;
                case "pan":
                case "panTouchDrag":
                case "panMultiTouch":
                    className += "move";
                    break;
                case "stackScroll":
                case "stackScrollWheel":
                case "stackScrollTouchDrag":
                    className += "stack";
                    break;
                case "length":
                case "lengthTouch":
                case "stackScrollTouchDrag":
                    className += "length-measurement";
                    break;
                case "simpleAngle":
                case "simpleAngleTouch":
                    className += "angle";
                    break;
                case "probe":
                case "probeTouch":
                    className += "pixel-probe";
                    break;
                case "ellipticalRoi":
                case "ellipticalRoiTouch":
                    className += "elliptical-roi";
                    break;
                case "rectangleRoi":
                case "rectangleRoiTouch":
                    className += "rectangle-roi";
                    break;
                case "highlight":
                    className += "highlight";
                    break;
                case "crop":
                    className += "crop";
                    break;
                case "freehand":
                    className += "pencil-ruler";
                    break;
                case "magnify":
                case "magnifyTouchDrag":
                    className += "magnifier";
                    break;
                case "brush":
                    className += "brush";
                    html =
                        '<span class="palet"></span><span class="tip"></span><span class="circle_mix"></span><span class="stain_1"></span><span class="stain_2"></span><span class="stain_3"></span><span class="stain_4 .tip"></span><span class="stain_5"></span><span class="stain_6"></span><span class="stain_7"></span><span class="stain_8"></span>';
                    break;
            }
            $('.tool_active[data-icon="' + button + '"] span')
                .addClass(className)
                .html(html);
        },
        /*
         * Vetology.PatientSwissKnife._getButtonName
         *
         * @description	Returns a human understandable name of a button;
         *
         * @return NULL
         *
         */
        _getButtonName: function (name) {
            switch (name) {
                case "leftMouse":
                case 1:
                    return "left mouse button";
                case "centerMouse":
                case 2:
                    return "center mouse button";
                case "rightMouse":
                case 4:
                    return "right mouse button";
                case "scrollMouse":
                case 6:
                    return "mouse scroll";
                case "touch":
                case 7:
                    return "touch gesture";
                case "multiTouch":
                case 8:
                    return "multi-touch gesture";
                case "pinch":
                case 9:
                    return "pinch gesture";
                case "touchAndDrag":
                case 10:
                    return "touch and drag gesture";
            }
        },
        /*
         * Vetology.PatientSwissKnife._getButtonIDByName
         *
         * @description	Returns the id of a button by name;
         *
         * @return NULL
         *
         */
        _getButtonIDByName: function (name) {
            switch (name) {
                case "leftMouse":
                    return 1;
                case "centerMouse":
                    return 2;
                case "rightMouse":
                    return 4;
                case "scrollMouse":
                    return 6;
                case "touch":
                    return 7;
                case "multiTouch":
                    return 8;
                case "pinch":
                    return 9;
                case "touchAndDrag":
                    return 10;
            }
        },
        /*
         * Vetology.PatientSwissKnife._enableCornerstoneTool
         *
         * @description	Enables a particular cornerstone tool;
         *
         * @return NULL
         *
         */
        _enableCornerstoneTool: function (o, el) {
            /*o.options.cornerstone.elements*/
            var tool = el.data("tool");
            var button = el.closest(".tool_touch_button_selector").data("action");
            var parent = el.closest("div");
            var global_parent = parent.closest(".interface_tools");
            var resetTools = true;
            var confirmChange = true;
            $.each(o.options.cornerstone.tools.active, function (i, activeTool) {
                if (tool == activeTool) {
                    confirmChange = confirm(
                        "The selected tool is already assigned to the " +
                            o._getButtonName(i) +
                            ".\n\nAre you sure you want to disable the tool on " +
                            o._getButtonName(i) +
                            " and enable it on " +
                            o._getButtonName(button)
                    );
                    if (confirmChange) {
                        o.options.cornerstone.tools.active[i] = "";
                        $('.tool_button[data-action="' + o._getButtonIDByName(i) + '"')
                            .find(".tool_active")
                            .html("");
                    }
                }
            });
            if (!confirmChange) {
                return false;
            }
            if (
                $.inArray(tool, [
                    "invert",
                    "rotatecw",
                    "rotateccw",
                    "fliph",
                    "flipv",
                    "play",
                    "stop",
                    "save_as_png",
                    "save_as_jpeg",
                ]) === -1 &&
                tool.indexOf("clear") === -1
            ) {
                switch (button) {
                    case 1:
                        o.options.cornerstone.tools.active.leftMouse = tool;
                        break;
                    case 2:
                        o.options.cornerstone.tools.active.centerMouse = tool;
                        break;
                    case 4:
                        o.options.cornerstone.tools.active.rightMouse = tool;
                        break;
                    case 6:
                        o.options.cornerstone.tools.active.scrollMouse = tool;
                        break;
                    case 7:
                        o.options.cornerstone.tools.active.touch = tool;
                        break;
                    case 8:
                        o.options.cornerstone.tools.active.multiTouch = tool;
                        break;
                    case 9:
                        o.options.cornerstone.tools.active.pinch = tool;
                        break;
                    case 10:
                        o.options.cornerstone.tools.active.touchAndDrag = tool;
                        break;
                    default:
                        resetTools = false;
                        break;
                }
            } else {
                resetTools = false;
            }
            $.each(o.options.cornerstone.elements, function (i, element) {
                if (resetTools) {
                    $(".tool_buttons button").removeClass("active");
                    el.addClass("active");
                    o._resetAllCornerstoneTools(o, element);
                    return true;
                }
                if ($(element).closest(".vetology_canvas_active").length == 0) {
                    return;
                }
                if ($.inArray(tool, ["invert", "rotatecw", "rotateccw", "fliph", "flipv"]) !== -1) {
                    var p = $(element);
                    var viewport = cornerstone.getViewport(element);
                    switch (tool) {
                        case "invert":
                            if (viewport.invert === true) {
                                viewport.invert = false;
                            } else {
                                viewport.invert = true;
                            }
                            break;
                        case "rotatecw":
                            viewport.rotation += 90;
                            break;
                        case "rotateccw":
                            viewport.rotation -= 90;
                            break;
                        case "fliph":
                            if (viewport.rotation == 90 || viewport.rotation == -90) {
                                viewport.vflip = !viewport.vflip;
                            } else {
                                viewport.hflip = !viewport.hflip;
                            }
                            break;
                        case "flipv":
                            if (viewport.rotation == 90 || viewport.rotation == -90) {
                                viewport.hflip = !viewport.hflip;
                            } else {
                                viewport.vflip = !viewport.vflip;
                            }
                            break;
                    }
                    cornerstone.setViewport(element, viewport);
                } else if ($.inArray(tool, ["play", "stop"]) !== -1) {
                    var fps = el.closest(".tool_button_switch_block").find(".fps");
                    switch (tool) {
                        case "play":
                            fps.attr("disabled", "disabled").addClass("disabled");
                            el.data("tool", "stop");
                            el.find("span").attr("class", "vetology-stop");
                            var stackState = cornerstoneTools.getToolState(element, "stack");
                            var frameRate = parseInt(fps.val(), 10);
                            if (frameRate < 1) {
                                frameRate = 10;
                            }
                            cornerstoneTools.playClip(element, frameRate);
                            break;
                        case "stop":
                            fps.removeAttr("disabled", "disabled").removeClass("disabled");
                            el.data("tool", "play");
                            el.find("span").attr("class", "vetology-play");
                            cornerstoneTools.stopClip(element);
                            break;
                    }
                } else if (tool.indexOf("clear") !== -1) {
                    tool = tool.replace("clear_", "");
                    if (tool == "all") {
                        cornerstoneTools.clearToolState(element, "probe");
                        cornerstoneTools.clearToolState(element, "length");
                        cornerstoneTools.clearToolState(element, "ellipticalRoi");
                        cornerstoneTools.clearToolState(element, "rectangleRoi");
                        cornerstoneTools.clearToolState(element, "simpleAngle");
                        cornerstoneTools.clearToolState(element, "angle");
                        cornerstoneTools.clearToolState(element, "highlight");
                        cornerstoneTools.clearToolState(element, "freehand");
                        cornerstoneTools.clearToolState(element, "brush");
                    } else {
                        cornerstoneTools.clearToolState(element, tool);
                    }
                    cornerstone.updateImage(element);
                } else if (tool == "save_as_png") {
                    cornerstoneTools.saveAs(element, o.options.patient.name + " - " + new Date().getTime() + ".png");
                } else if (tool == "save_as_jpeg") {
                    cornerstoneTools.saveAs(
                        element,
                        o.options.patient.name + " - " + new Date().getTime() + ".jpg",
                        "image/jpeg"
                    );
                }
            });
            return true;
        },
        /*
         * Vetology.PatientSwissKnife._initCornerstone
         *
         * @description	Initializes cornerstone with settings and also adds event handlers to the buttons;
         *
         * @return NULL
         *
         */
        _initCornerstone: function (o) {
            cornerstoneWebImageLoader.external.cornerstone = cornerstone;
            var configuration = cornerstoneTools.zoom.getConfiguration();
            configuration = cornerstoneTools.panMultiTouch.getConfiguration();
            configuration = cornerstoneTools.orientationMarkers.getConfiguration();
            cornerstoneTools.zoom.setConfiguration(o.options.cornerstone.tools.configZoom);
            cornerstoneTools.panMultiTouch.setConfiguration(o.options.cornerstone.tools.configPanMultitouch);
            cornerstoneTools.orientationMarkers.setConfiguration(o.options.cornerstone.tools.orientationMarkers);
            cornerstoneTools.brush.setConfiguration(o.options.cornerstone.tools.brush);
            o.options.cornerstone.buttons.parent = $(o.options.cornerstone.buttons.parent);
            o.options.cornerstone.buttons.parent.on("click", ".tool_button_switch", function (e) {
                e.preventDefault();
                var el = $(this);
                if (!el.hasClass("active")) {
                    var continueProcess = o._enableCornerstoneTool(o, el);
                }
                if (!continueProcess) {
                    return;
                }
                if (el.hasClass("tool_global")) {
                    return;
                }
                var toolManager = el.closest(".tool_touch_button_selector");
                var action =
                    toolManager.data("action"); /*This is the device where the functionality is to be activated*/
                var tool = el.data("tool");
                toolManager.find(".tool_buttons button").removeClass("active");
                el.addClass("active");
                toolManager.find(".tool_button").each(function (a, b) {
                    b = $(b);
                    if (b.data("tool") == tool) {
                        b.data("tool", -1);
                    }
                });
                toolManager.find('.tool_button[data-action="' + action + '"]').data("tool", tool);
            });
            cornerstone.registerImageLoader("vetology", function (imageId) {
                var o = this;
                var promise = new Promise(function (resolve, reject) {
                    var crypt = imageId.replace("vetology:", "");
                    $.when($("body").VetologyCache("imageReady", crypt, 3)).then(
                        function () {
                            $.when($("body").VetologyCache("loadImage", crypt)).then(
                                function (image) {
                                    resolve(image);
                                },
                                function (crypt, event) {
                                    reject(crypt, event);
                                }
                            );
                        },
                        function (crypt, event) {
                            reject(crypt, event);
                        }
                    );
                });
                return {
                    promise: promise,
                    cancelFn: function () {},
                };
            });
            o.options.cornerStoneCanvas = {
                canvas: document.createElement("canvas"),
                id: null,
            };
            $(document).on("vetology_image_loaded", function (event) {
                o.options.load_manager.loaded++;
                o._updateDataLoadedConsole();
            });
            cornerstone.events.addEventListener("cornerstoneimageloaded", function (e) {
                o.options.load_manager.loaded++;
                o._updateDataLoadedConsole();
            });
            $(document).on("vetology_image_progress", function (event) {
                if (typeof event.detail == "undefined") {
                    return;
                }
                var detail = event.detail;
                var img = o.options.load_manager.images[detail.imageId];
                if (typeof img == "undefined") {
                    return;
                }
                img.percentComplete = detail.percentComplete;
                img.loaded = detail.loaded;
                img.total = detail.total;
                img.cached = detail.cached;
                img.is_completed = detail.is_completed;
                o.options.load_manager.images[detail.imageId] = img;
                var series = o.options.load_manager.images[detail.imageId].series;
                var series_index = o.options.load_manager.images[detail.imageId].series_index;
                var className = o.options.load_manager.images[detail.imageId].is_im
                    ? ".series_loader_im"
                    : ".series_loader_iv";
                var is_compare = o.options.load_manager.images[detail.imageId].is_im;
                var seriesUpdate = {};
                var totalLoad = 0;
                var totalCount = 0;
                var totalReady = 0;
                var totalCached = 0;
                $.each(o.options.load_manager.images, function (i, img) {
                    var si = img.series + img.series_index;
                    if (typeof seriesUpdate[si] == "undefined") {
                        seriesUpdate[si] = {
                            im: {
                                count: 0,
                                total: 0,
                                percentComplete: 0,
                                loaded: 0,
                                className: ".series_loader_im",
                                series: img.series,
                                index: img.series_index,
                            },
                            iv: {
                                count: 0,
                                total: 0,
                                percentComplete: 0,
                                loaded: 0,
                                className: ".series_loader_iv",
                                series: img.series,
                                index: img.series_index,
                            },
                        };
                    }
                    var p = img.is_im ? "im" : "iv";
                    seriesUpdate[si][p].total += img.total;
                    seriesUpdate[si][p].percentComplete += img.percentComplete;
                    seriesUpdate[si][p].loaded += img.loaded;
                    seriesUpdate[si][p].count++;
                    totalCount++;
                    if (img.is_completed) {
                        totalReady++;
                    }
                    totalLoad += img.total;
                    totalCached += img.cached;
                });
                $.each(seriesUpdate, function (i, sb) {
                    $.each(sb, function (a, d) {
                        var progressBar = $('[data-series_id="' + d.series + '"]')
                            .find(d.className + '[data-series="' + d.index + '"]')
                            .find(".progress-bar");
                        const isDiagnosis = progressBar.get(0).closest(".interface_image_diagnosys") != null;
                        if (progressBar.hasClass("is_ready")) {
                            return true;
                        }
                        var percentComplete = isDiagnosis ? 100 : d.percentComplete / (d.count || 1);
                        var percentCompleteFormatted =
                            percentComplete == 100 ? percentComplete : percentComplete.toFixed(2);
                        progressBar
                            .css({ width: percentComplete + "%" })
                            .find("span")
                            .html(percentCompleteFormatted + "% Complete (loading)");
                        if (percentComplete == 100) {
                            progressBar
                                .removeClass("progress-bar-warning active progress-bar-striped")
                                .addClass("progress-bar-success is_ready")
                                .find("span")
                                .html("100% Complete (loaded)");
                        }
                    });
                });
                var i = -1;
                var byteUnits = [" kB", " MB", " GB", " TB", "PB", "EB", "ZB", "YB"];
                do {
                    totalLoad = totalLoad / 1024;
                    i++;
                } while (totalLoad > 1024);
                o.options.load_manager.downloaded = Math.max(totalLoad, 0.1).toFixed(1) + byteUnits[i];
                var i = -1;
                var byteUnits = [" kB", " MB", " GB", " TB", "PB", "EB", "ZB", "YB"];
                do {
                    totalCached = totalCached / 1024;
                    i++;
                } while (totalCached > 1024);
                o.options.load_manager.cached = Math.max(totalCached, 0.1).toFixed(1) + byteUnits[i];
                o._updateDataLoadedConsole();
            });
            cornerstone.events.addEventListener("cornerstoneimageloadprogress", function (event) {
                var detail = event.detail;
                var img = o.options.load_manager.images[detail.imageId];
                if (typeof img == "undefined") {
                    return;
                }
                img.percentComplete = detail.percentComplete;
                img.loaded = detail.loaded;
                img.total = detail.total;
                img.cached = detail.cached;
                img.is_completed = detail.is_completed;
                o.options.load_manager.images[detail.imageId] = img;
                var series = o.options.load_manager.images[detail.imageId].series;
                var series_index = o.options.load_manager.images[detail.imageId].series_index;
                var className = o.options.load_manager.images[detail.imageId].is_im
                    ? ".series_loader_im"
                    : ".series_loader_iv";
                var is_compare = o.options.load_manager.images[detail.imageId].is_im;
                var seriesUpdate = {};
                var totalLoad = 0;
                var totalCount = 0;
                var totalReady = 0;
                var totalCached = 0;
                $.each(o.options.load_manager.images, function (i, img) {
                    var si = img.series + img.series_index;
                    if (typeof seriesUpdate[si] == "undefined") {
                        seriesUpdate[si] = {
                            im: {
                                count: 0,
                                total: 0,
                                percentComplete: 0,
                                loaded: 0,
                                className: ".series_loader_im",
                                series: img.series,
                                index: img.series_index,
                            },
                            iv: {
                                count: 0,
                                total: 0,
                                percentComplete: 0,
                                loaded: 0,
                                className: ".series_loader_iv",
                                series: img.series,
                                index: img.series_index,
                            },
                        };
                    }
                    var p = img.is_im ? "im" : "iv";
                    seriesUpdate[si][p].total += img.total;
                    seriesUpdate[si][p].percentComplete += img.percentComplete;
                    seriesUpdate[si][p].loaded += img.loaded;
                    seriesUpdate[si][p].count++;
                    totalCount++;
                    if (img.is_completed) {
                        totalReady++;
                    }
                    totalLoad += img.total;
                    totalCached += img.cached;
                });
                $.each(seriesUpdate, function (i, sb) {
                    $.each(sb, function (a, d) {
                        var progressBar = $('[data-series_id="' + d.series + '"]')
                            .find(d.className + '[data-series="' + d.index + '"]')
                            .find(".progress-bar");
                        if (progressBar.hasClass("is_ready")) {
                            return true;
                        }
                        var percentComplete = d.percentComplete / d.count;
                        var percentCompleteFormatted =
                            percentComplete == 100 ? percentComplete : percentComplete.toFixed(2);
                        progressBar
                            .css({ width: percentComplete + "%" })
                            .find("span")
                            .html(percentCompleteFormatted + "% Complete (loading)");
                        if (percentComplete == 100) {
                            progressBar
                                .removeClass("progress-bar-warning active progress-bar-striped")
                                .addClass("progress-bar-success is_ready")
                                .find("span")
                                .html("100% Complete (loaded)");
                        }
                    });
                });
                var i = -1;
                var byteUnits = [" kB", " MB", " GB", " TB", "PB", "EB", "ZB", "YB"];
                do {
                    totalLoad = totalLoad / 1024;
                    i++;
                } while (totalLoad > 1024);
                o.options.load_manager.downloaded = Math.max(totalLoad, 0.1).toFixed(1) + byteUnits[i];
                var i = -1;
                var byteUnits = [" kB", " MB", " GB", " TB", "PB", "EB", "ZB", "YB"];
                do {
                    totalCached = totalCached / 1024;
                    i++;
                } while (totalCached > 1024);
                o.options.load_manager.cached = Math.max(totalCached, 0.1).toFixed(1) + byteUnits[i];
                o._updateDataLoadedConsole();
            });
        },
        _getBytesInHR: function (bytes) {
            var i = -1;
            var byteUnits = [" kB", " MB", " GB", " TB", "PB", "EB", "ZB", "YB"];
            do {
                bytes = bytes / 1024;
                i++;
            } while (bytes > 1024);
            return Math.max(bytes, 0.1).toFixed(1) + byteUnits[i];
        },
        _updateDataLoadedConsole: function () {
            var o = this;
            var data = $("body").VetologyCache("getLoadedDataSet");
            $(".data_downloaded")
                .find("span")
                .html(o._getBytesInHR(data.downloaded_bytes) + "/" + o._getBytesInHR(data.cached_bytes));
            $(".data_completed_total")
                .find("span")
                .html(data.downloaded + data.cached + "/" + data.total);
            $(".data_seconds_elapsed")
                .find("span")
                .html(((o.options.download_ended_at - o.options.download_started_at) / 1000).toFixed(0));
        },
        loadImage: function (imageId) {
            var o = this;
            var promise = new Promise(function (resolve, reject) {
                var crypt = imageId.replace("vetology:", "");
                $.when($("body").VetologyCache("imageReady", crypt, 3)).then(
                    function () {
                        $.when($("body").VetologyCache("loadImage", crypt)).then(
                            function (image) {
                                resolve(image);
                            },
                            function (crypt, event) {
                                reject(crypt, event);
                            }
                        );
                    },
                    function (crypt, event) {
                        reject(crypt, event);
                    }
                );
            });
            return {
                promise: promise,
                cancelFn: function () {},
            };
        },
        /*
         * Vetology.PatientSwissKnife._imageViewerHandlers
         *
         * @description	Initializes the event handlers for the image viewer
         *
         * @return NULL
         *
         */
        _imagePrepareUpdateImage: function (crypt, id) {
            var o = this;
            var images = $("img." + crypt.id);
            $.each(images, function (i, img) {
                img = $(img);
                var tn = img.data("tn");
                $.when($("body").VetologyCache("imageThumbsReady", id)).then(function (crypt) {
                    if (typeof tn != "undefined") {
                        var rendered = false;
                        switch (tn) {
                            case 4:
                                if (crypt.sidebar_left) {
                                    img.attr("src", crypt.sidebar_left);
                                    rendered = true;
                                }
                                break;
                            case 3:
                                if (crypt.sidebar_right) {
                                    img.attr("src", crypt.sidebar_right);
                                    rendered = true;
                                }
                                break;
                            case 2:
                                if (crypt.pagination_small) {
                                    img.attr("src", crypt.pagination_small);
                                    rendered = true;
                                }
                                break;
                            case 1:
                                if (crypt.pagination_medium) {
                                    img.attr("src", crypt.pagination_medium);
                                    rendered = true;
                                }
                                break;
                        }
                        if (!rendered) {
                            var url = o._getRandomUrl(id, tn);
                            img.attr("src", url);
                        }
                    } else {
                        var url = o._getRandomUrl(id);
                        img.attr("src", url);
                    }
                });
            });
        },
        /*
         * Vetology.PatientSwissKnife._imageViewerHandlers
         *
         * @description	Initializes the event handlers for the image viewer
         *
         * @return NULL
         *
         */
        _imagePrepare: function (crypt, callback, param1, param2, param3, param4, param5) {
            var o = this;
            if (typeof o.options.image_loader[crypt] === "undefined") {
                o.options.image_loader[crypt] = {
                    id: $("body").Vetology("getUniqueIdentifier"),
                    loaded: false,
                };
            }
            $.when($("body").VetologyCache("imageReady", crypt, 3)).then(function (data) {
                o.options.image_loader[crypt].loaded = true;
                o.options.image_loader[crypt].sidebar_left = data.sidebar_left;
                o.options.image_loader[crypt].sidebar_right = data.sidebar_right;
                o.options.image_loader[crypt].pagination_small = data.pagination_small;
                o.options.image_loader[crypt].pagination_medium = data.pagination_medium;
                o._imagePrepareUpdateImage(o.options.image_loader[crypt], crypt);
                if (typeof callback === "function") {
                    return callback(crypt, param1, param2, param3, param4, param5);
                }
            });
            return o.options.image_loader[crypt].id;
        },
        /*
         * Vetology.PatientSwissKnife._getRandomUrl
         *
         * @description	Initializes the event handlers for the image viewer
         *
         * @return NULL
         *
         */
        _getRandomUrl: function (id, tn) {
            if (id == "no_matches") {
                return "no_matches";
            }
            return (
                this.options.downloadBuckets[Math.floor(Math.random() * this.options.downloadBuckets.length)] +
                "download/" +
                id +
                (typeof tn != "undefined" ? "?tn=" + tn : "")
            );
        },
        /*
         * Vetology.PatientSwissKnife._imageViewerHandlers
         *
         * @description	Initializes the event handlers for the image viewer
         *
         * @return NULL
         *
         */
        _imageViewerHandlers: function (o) {
            $("body").on("click", o.options.tools.image_viewer, function (e) {
                $("body").removeClass("image_match_active").addClass("image_viewer_active license_manage");
                $(".vetology_canvas").removeClass("vetology_canvas_active");
                $(o.options.interfaces.global).addClass("hide");
                $(o.options.interfaces.image_viewer.main)
                    .removeClass("hide")
                    .find(".vetology_canvas")
                    .addClass("vetology_canvas_active");
                o._enableImageViewerCanvas(
                    o,
                    o.options.interfaces.image_viewer.series,
                    o.options.interfaces.image_viewer.series,
                    o.options.interfaces.image_diagnosys.series
                );
                $(window).resize();
            });
        },
        /*
         * Vetology.PatientSwissKnife._diagnosysHandlers
         *
         * @description	Initializes the event handlers for the image diagnosys
         *
         * @return NULL
         *
         */
        /*
         * Vetology.PatientSwissKnife._adjustRenderedStudiesHeight
         *
         * @description Calculates and sets the height of .rendered_studies
         *              to enable scrolling only in the image list section
         *
         * @return NULL
         */
        _adjustRenderedStudiesHeight: function() {
            var o = this;
            var $renderedStudies = $(".rendered_studies");

            if ($renderedStudies.length === 0) {
                return; // Element not yet rendered
            }

            var $seriesNav = $(".vetology_series_nav");
            if ($seriesNav.length === 0) {
                return;
            }

            // Get viewport height
            var viewportHeight = $(window).height();

            // Fixed header height (from PatientManager.scss line 12)
            var headerHeight = 80;

            // Get the actual height of all elements above .rendered_studies
            var navHeight = 0;
            $seriesNav.children().each(function() {
                if (!$(this).hasClass("rendered_studies")) {
                    navHeight += $(this).outerHeight(true); // Include margins
                }
            });

            // Calculate available height for rendered_studies
            // viewport - header - nav elements - padding buffer
            var availableHeight = viewportHeight - headerHeight - navHeight - 20;

            // Set minimum height to prevent collapse
            var minHeight = 200;
            var finalHeight = Math.max(availableHeight, minHeight);

            $renderedStudies.css({ height: finalHeight + "px" });
        },
        _diagnosysHandlers: function (o) {
            $("body").on("click", o.options.tools.image_diagnosys, function (e) {
                $("body").addClass("image_match_active").removeClass("image_viewer_active license_manage");
                $(o.options.interfaces.global).addClass("hide");
                $(o.options.interfaces.image_diagnosys.main)
                    .removeClass("hide")
                    .find(".vetology_canvas_2")
                    .addClass("vetology_canvas_active");
                $("body").addClass(o.options.body_loading);
                o._enableDiagnosysCanvas(o, o.options.series.current.ai);
                $(window).resize();
            });
        },
        /*
         * Vetology.PatientSwissKnife._enableDiagnosysCanvas
         *
         * @description	 Checks if canvas has already been enabled, if not enables it
         *
         * @return NULL
         *
         */
        _enableDiagnosysCanvas: function (o, series) {
            if (typeof o.options.canvas.image_diagnosys.element_main === "undefined") {
                // hide marker switch
                const onOffSwitch = document.querySelector(".marker-switch-container");
                onOffSwitch.style.opacity = 0;

                /*Get the active series*/
                o.options.canvas.image_diagnosys.element_main = $(
                    o.options.canvas.image_diagnosys.original.container
                ).find(o.options.canvas.image_diagnosys.original.canvas);
                o.options.canvas.image_diagnosys.element_compare = $(
                    o.options.canvas.image_diagnosys.compare.container
                ).find(o.options.canvas.image_diagnosys.compare.canvas);
                var cont_width = o.options.canvas.image_diagnosys.element_main.width();
                var cont_height = cont_width * o.options.ratio;
                var height = $(window).height();
                var width = $(".width_sampler").width();
                $(o.options.canvas.image_diagnosys.element_compare).on(
                    "CornerstoneImageRendered",
                    o._onViewportUpdated
                );
                $(o.options.canvas.image_diagnosys.element_main).on("CornerstoneImageRendered", o._onViewportUpdated);
                o.options.canvas.image_diagnosys.element_compare.css({
                    width: cont_width + "px",
                    height: cont_height + "px",
                });
                o.options.canvas.image_diagnosys.element_main.css({
                    width: cont_width + "px",
                    height: cont_height + "px",
                });
                o.options.canvas.image_diagnosys.dicom_main = o.options.canvas.image_diagnosys.element_main.get(0);
                o.options.canvas.image_diagnosys.dicom_compare =
                    o.options.canvas.image_diagnosys.element_compare.get(0);
                if (typeof $("body").data("indexed_series") !== "undefined") {
                    series = $("body").data("indexed_series");
                    $("body").removeData("indexed_series");
                }
                if (typeof o.options.series.data.all[series] != "undefined") {
                    series = o.options.series.data.all[series];
                } else {
                    console.error("The requested series do not exist");
                    return false;
                }
                if (
                    typeof o.options.patient.series_match_preload !== "undefined" &&
                    typeof o.options.series.data.all[o.options.patient.series_match_preload] !== "undefined"
                ) {
                    series = o.options.series.data.all[o.options.patient.series_match_preload];
                    $(".series_loader_im.series_loader").removeClass("active active_series");
                    $(
                        '.series_loader_im.series_loader[data-series="' + o.options.patient.series_match_preload + '"]'
                    ).addClass("active active_series");
                }
                o._cornerStoneEnableElement(series, o.options.canvas.image_diagnosys.dicom_main, false);
                /*
                 * This is the second canvas for comparison of images;
                 * o.options.patient.image_match_preload is the index of the purchases report
                 */
                o._cornerStoneEnableElement(series, o.options.canvas.image_diagnosys.dicom_compare, true);
                $(o.options.canvas.image_diagnosys.dicom_compare).contextmenu(function (e) {
                    o._doContextMenu(o.options.canvas.image_diagnosys.dicom_compare, e);
                });
                $(o.options.canvas.image_diagnosys.dicom_main).contextmenu(function (e) {
                    o._doContextMenu(o.options.canvas.image_diagnosys.dicom_main, e);
                });
            }
        },
        /*
         * Vetology.PatientSwissKnife._onViewportUpdated
         *
         * @description	 Listen for changes to the viewport so we can update the text overlays
         *
         * @return NULL
         *
         */
        _doContextMenu: function (element, e) {
            if (e.ctrlKey) {
                var o = this;
                var stack = cornerstoneTools.getElementToolStateManager(element);
                console.log(stack);
                try {
                    var appState = cornerstoneTools.appState.save([element]);
                    console.log(appState);
                } catch (e) {
                    console.log(e);
                }
                var index = stack.toolState.stack.data[0].currentImageIdIndex;
                var imageId = stack.toolState.stack.data[0].imageIds[index].replace("vetology:", "");
                var url = "/download/" + imageId;
                $(".dropdown.contextmenu").remove();
                var oe = e.originalEvent;
                var top = oe.clientY;
                var left = oe.clientX;
                var html = '<div class="dropdown contextmenu open">';
                html += '<ul class="dropdown-menu">';
                html +=
                    '<li><a href="' + url + '" target="_blank" class="view_original_jpeg">View untouched JPEG</a></li>';
                html += '<li><a href="#" class="debug_stack vetology_pd">Debug Stack</a></li>';
                html += '<li><a href="#" class="vetology_pd">Close</a></li>';
                html += "</ul>";
                html += "</div>";
                $("body").append(html);
                $(".dropdown.contextmenu")
                    .find(".debug_stack")
                    .on("click", function () {
                        console.log("Current Case ID: " + stack.toolState.stack.data[0].imageDataSet[index].case_id);
                        console.log("Current Image ID: " + stack.toolState.stack.data[0].imageDataSet[index].image_id);
                        console.log(
                            "Current Original image link: " +
                                stack.toolState.stack.data[0].imageDataSet[index].original_image
                        );
                        console.log("All Stack:", stack);
                    });
                $(".dropdown.contextmenu")
                    .css({ top: top, left: left })
                    .find("a")
                    .on("click", function () {
                        $(".dropdown.contextmenu").remove();
                    });
            }
        },
        /*
         * Vetology.PatientSwissKnife._enableImageViewerCanvas
         *
         * @description	 Checks if canvas has already been enabled, if not enables it
         *
         * @return NULL
         *
         */
        _enableImageViewerCanvas: function (o, series) {
            if (typeof o.options.canvas.image_viewer.element === "undefined") {
                o.options.canvas.image_viewer.element_main = $(o.options.canvas.image_viewer.container).find(
                    o.options.canvas.image_viewer.canvas
                );
                o.options.canvas.image_viewer.element_main.addClass("vetology_canvas_active");
                var cont_width = o.options.canvas.image_viewer.element_main.width();
                var cont_height = cont_width * o.options.ratio;
                var height = $(window).height();
                var width = $(".width_sampler").width();
                o.options.canvas.image_viewer.element_main.on("CornerstoneImageRendered", o._onViewportUpdated);
                o.options.canvas.image_viewer.element_main.css({ width: width + "px", height: height - 120 });
                o.options.canvas.image_viewer.element = o.options.canvas.image_viewer.element_main.get(0);
                if (
                    typeof o.options.patient.series_preload != "undefined" &&
                    typeof o.options.series[o.options.patient.series_preload] != "undefined"
                ) {
                    series = o.options.patient.series_preload;
                }
                var serieso = o.options.series.data.all[series];
                o._cornerStoneEnableElement(serieso, o.options.canvas.image_viewer.element, false);
                $(".series_loader_iv.series_loader").removeClass("active active_series");
                $('.series_loader_iv.series_loader[data-series="' + series + '"]').addClass("active active_series");
                $(o.options.canvas.image_viewer.element).contextmenu(function (e) {
                    o._doContextMenu(o.options.canvas.image_viewer.element, e);
                });

                if (o.options.canvas.image_viewer.element_main.data("show_annotations") == "1") {
                    // insert annotator into the canvas
                    const annotator = document.createElement("image-annotator");
                    const canvas = o.options.canvas.image_viewer.element_main.get(0).querySelector("canvas");
                    canvas.appendChild(annotator);
                }
            }
        },
        /*
         * Vetology.PatientSwissKnife._onViewportUpdated
         *
         * @description	 Listen for changes to the viewport so we can update the text overlays
         *
         * @return NULL
         *
         */
        _onViewportUpdated: function (e) {
            var viewport = cornerstone.getViewport(e.target);
            /*Do something*/
        },
        /*
         * Vetology.PatientSwissKnife._getAccuracyData
         *
         * @description	 Listen for changes to the stack change so we can update the text overlays
         *
         * @return NULL
         *
         */
        _getAccuracyData: function (level) {
            var data = {
                level: level,
            };
            switch (true) {
                case level < 40.01:
                    data.class = "great";
                    data.word = "Strong";
                    break;
                case level < 50.01:
                    data.class = "average";
                    data.word = "Fair";
                    break;
                default:
                    data.class = "very_bad";
                    data.word = "Poor";
                    break;
            }
            return data;
        },
        /*
         * Vetology.PatientSwissKnife._updateCornerstoneStackState
         *
         * @description	 Listen for changes to the stack change so we can update the text overlays
         *
         * @return NULL
         *
         */
        _updateCornerstoneStackState: function (element) {
            var o = this;
            var stack = cornerstoneTools.getElementToolStateManager(element);
            var index = stack.toolState.stack.data[0].currentImageIdIndex;
            /*var accuracy = o._getAccuracyData(stack.toolState.stack.data[0].imageData[index]);*/
            var pagination = $(element).closest(".interface_workarea").find(".pagination");
            pagination.find("li").removeClass("active");
            $.each(pagination.find("li"), function (i, li) {
                if (i == index) {
                    $(li).addClass("active");
                }
            });
            o._updatePaginationResponsivenes(pagination, 2, 3, index);
            /*here we can do whatever we want with this info*/
        },
        /*
         * Vetology.PatientSwissKnife._updatePaginationResponsivenes
         *
         * @description	 Listen for changes to the stack change so we can update the text overlays
         *
         * @return NULL
         *
         */
        _updatePaginationResponsivenes: function (pagination, allowed_lis, limit, start_index) {
            var o = this;
            const customEvent = new CustomEvent("cornerstone-invalidated", { detail: { pagination: pagination } });
            const vCanvas = document.querySelector(".vetology_canvas");
            vCanvas.dispatchEvent(customEvent);

            $.each($(".pagination_stack_scroll"), function (i, pagination) {
                pagination = $(pagination);
                pagination.find(".li_remove").remove();
                pagination.find(".static_controls").remove();
                var last = pagination.data("last");
                var lis = pagination.find("li");
                var divs = $(".match_thumb");
                divs.removeClass("match_thumb_more active").addClass("hide");
                var start = false;
                var limit = 7;
                var limit_initial = 7;
                var len = divs.length - 1;
                var div_start = start_index;
                if (len <= 7 || div_start == 1 || div_start == 2 || div_start == 3 || div_start == 4) {
                    div_start = 0;
                } else if (div_start > 4) {
                    div_start -= 4;
                }
                $.each(divs, function (i, div) {
                    if (div_start == i) {
                        start = true;
                    }
                    if (limit > 0 && start) {
                        $(div).removeClass("hide");
                        if (i == start_index) {
                            $(div).addClass("active");
                        }
                        limit--;
                    } else if (limit == 0 && start) {
                        $(div).removeClass("hide").addClass("match_thumb_more");
                        limit--;
                        return false;
                    }
                });
                len = lis.length;
                lis.removeClass("active");
                $.each(lis, function (i, el) {
                    if (i == start_index) {
                        $(el).addClass("active");
                    }
                });
                if (len > 6) {
                    lis.addClass("hide");
                    var targetIndex = start_index;
                    if (targetIndex == 0) {
                        targetIndex += 2;
                    } else if (targetIndex == 1) {
                        targetIndex += 1;
                    } else {
                        targetIndex += 1;
                    }
                    len -= 3;
                    var current = pagination.find("li.active").removeClass("hide");
                    if (current.prev("li").length > 0) {
                        current.prev("li").removeClass("hide");
                    } else {
                        current = current.next("li").removeClass("hide");
                    }
                    if (current.next("li").length > 0) {
                        current = current.next("li").removeClass("hide");
                        if (current.next("li").next("li").length > 0) {
                            var t_index = current.next("li").next("li").find("a").data("index");
                            current.after(
                                '<li class="li_remove"><a hrf="#" class="vetology_pd set_stack_index_alt" data-index="' +
                                    t_index +
                                    '">&nbsp;...</a></li>'
                            );
                        } else if (current.next("li").length > 0) {
                            var t_index = current.next("li").find("a").data("index");
                            current.after(
                                '<li class="li_remove"><a hrf="#" class="vetology_pd set_stack_index_alt" data-index="' +
                                    t_index +
                                    '">&nbsp;...</a></li>'
                            );
                        }
                    } else if (current.prev("li").prev("li").prev("li").length > 0) {
                        current = current.prev("li").prev("li").prev("li").removeClass("hide");
                    }
                }
                if (pagination.closest(".interface_workarea").hasClass("vetology_canvas_2_container")) {
                    if (pagination.find("li.active").length > 0) {
                        o._updatePaginationAccuracyLevels(pagination, last);
                    } else {
                        setTimeout(function () {
                            if (pagination.find("li.active").length > 0) {
                                o._updatePaginationAccuracyLevels(pagination, last);
                            }
                        }, 3);
                    }
                }
            });
        },
        /*
         * Vetology.PatientSwissKnife._updatePagination
         *
         * @description	 Listen for changes to the stack change so we can update the text overlays
         *
         * @return NULL
         *
         */
        _updatePaginationAccuracyLevels: function (pagination, last) {
            var o = this;
            var last = pagination.find("ul").data("last");
            var level = pagination.find("li.active").find("a").data("accuracy");
            var word = pagination.find("li.active").find("a").data("word");
            if (level > 0) {
                var className = "pairing_image_status ";
                if (level < 40.01) {
                    className += "gauge_perfect";
                } else if (level < 50.01) {
                    className += "gauge_warning";
                } else {
                    className += "gauge_danger";
                }
                $(".pairing_image_status").attr("class", className).find(".pairing_percentage").html(word);
                o._setReportClass();
            } else {
                $(".pairing_image_status")
                    .attr("class", "pairing_image_status gauge_danger")
                    .find(".pairing_percentage")
                    .html("No");
            }
            pagination.find("li.static_controls").remove();
            var html =
                '<li class="static_controls"><a href="#" class="vetology_pd set_stack_index_alt" data-index="0"><i class="vetology-backward-last"></i></a></li>';
            html +=
                '<li class="static_controls"><a href="#" class="vetology_pd set_stack_index_alt" data-direction="left"><i class="vetology-backward"></i></a></li>';
            pagination.find("ul").prepend(html);
            html =
                '<li class="static_controls"><a href="#" class="vetology_pd set_stack_index_alt" data-direction="right"><i class="vetology-fordward"></i></a></li>';
            html +=
                '<li class="static_controls"><a href="#" class="vetology_pd set_stack_index_alt" data-index="' +
                last +
                '"><i class="vetology-fordward-last"></i></a></li>';
            pagination.find("ul").append(html);
            if (last < 2) {
                pagination.addClass("paginate_disable");
            } else {
                pagination.removeClass("paginate_disable");
            }
        },
        /*
         * Vetology.PatientSwissKnife._updatePagination
         *
         * @description	 Listen for changes to the stack change so we can update the text overlays
         *
         * @return NULL
         *
         */
        _updatePagination: function (element, pagination, index, stack, stackInfo) {
            // show Diagnosis match search
            if (stack.has_matches) {
                $(".report-keyword-search").slideDown();
            }
            var o = this;
            o.options.pagination.element = element;
            o.options.pagination.pagination = pagination;
            o.options.pagination.index = index;
            o.options.pagination.stack = stack;
            o.options.pagination.stackInfo = stackInfo;
            pagination = pagination.find("ul");
            pagination.html("");
            var pagination_style =
                o.options.search_config.pagination_format == 0
                    ? "pagination_thumbs"
                    : o.options.search_config.pagination_format == 1
                    ? ""
                    : o.options.search_config.pagination_format == 2
                    ? "pagination_thumbs pagination_thumbs_large"
                    : "";
            var thumbnails_small = o.options.search_config.pagination_format == 0;
            var thumbnails_large = o.options.search_config.pagination_format == 2;
            var withAccuracy = stack.imageData ? true : false;
            $(".pagination_stack_scroll")
                .removeClass("pagination_thumbs pagination_thumbs_large")
                .addClass(pagination_style);
            if (typeof stackInfo == "object" && stackInfo.length > 0) {
                pagination.data("last", stack.imageIds.length - 1);
                var limit = 7;
                var html_sidebar = "";
                var content = "";
                var html;
                $.each(stackInfo, function (i, m) {
                    content = 'data-html="true" ';
                    content += 'data-placement="top" ';
                    content += 'data-toggle="popover" ';
                    content += 'data-trigger="hover" ';
                    content += 'title="DICOM information" ';
                    content += 'data-container="body" ';
                    content += 'data-content="<ul>';
                    content += "<li>Image ID: " + m.image_id + "</li>";
                    content += m.edited_image_id ? "<li>Edited Image ID: " + m.edited_image_id : "";
                    content += "<li>Sex: " + m.sex + "</li>";
                    content += "<li>Species: " + m.species + "</li>";
                    content += "<li>Breed: " + m.breed + "</li>";
                    content += '</ul>"';
                    var sex = m.sex;
                    var sex = m.sex;
                    var active = index == i;
                    html = '<li class="' + (index == i ? "active" : "");
                    var id = m.crypt ? m.crypt : m.link;
                    id = o._imagePrepare(id);
                    if (withAccuracy && m.crypt != "no_matches") {
                        var accuracy = o._getAccuracyData(m.level);
                        html_sidebar += '<div class="match_thumb">';
                        html_sidebar +=
                            "<a " +
                            content +
                            ' href="#" class="vetology_pd pop_content" data-index="' +
                            i +
                            '" data-accuracy="' +
                            m.level +
                            '" data-word="' +
                            accuracy.word +
                            '">';
                        html_sidebar += '<img data-tn="3" class="' + id + '" src="/download/loading" />';
                        html_sidebar += '<span class="badge badge_index">' + (i + 1) + "</span>";
                        html_sidebar +=
                            '<span class="badge badge_level hide">' + (100 - m.level).toFixed(2) + "</span>";
                        html_sidebar += "</a>";
                        html_sidebar += "</div>";
                        html += " accuracy_" + accuracy.class + '">';
                        html +=
                            "<a " +
                            content +
                            '  href="#" class="vetology_pd pop_content" data-index="' +
                            i +
                            '" data-accuracy="' +
                            m.level +
                            '" data-word="' +
                            accuracy.word +
                            '">';
                    } else {
                        html += '"><a ' + content + ' href="#" class="vetology_pd pop_content" data-index="' + i + '">';
                    }
                    if (thumbnails_small) {
                        html +=
                            '<img data-tn="2" class="' +
                            id +
                            '" src="/download/loading" /><span class="badge">' +
                            (i + 1) +
                            "</span>";
                    } else if (thumbnails_large) {
                        html +=
                            '<img data-tn="1" class="' +
                            id +
                            '" src="/download/loading" /><span class="badge">' +
                            (i + 1) +
                            "</span>";
                    } else {
                        html += i + 1;
                    }
                    html += "</a>";
                    html += "</li>";
                    pagination.append(html);
                });
                $(".pagination_stack_scroll_thumbs_inner").html(html_sidebar);
            } else {
                $.each(stack.imageIds, function (i, id) {
                    var active = index == i;
                    html = '<li class="' + (index == i ? "active" : "");
                    if (withAccuracy) {
                        var accuracy = o._getAccuracyData(stack.imageData[i]);
                        html += " accuracy_" + accuracy.class + '">';
                        html +=
                            '<a href="#" class="vetology_pd" data-index="' +
                            i +
                            '" data-accuracy="' +
                            accuracy.level +
                            '">';
                    } else {
                        html += '"><a href="#" class="vetology_pd" data-index="' + i + '">';
                    }
                    html += i + 1;
                    html += "</a>";
                    html += "</li>";
                    pagination.append(html);
                });
            }

            // update FTS display status
            o._setFullTextSearchDisplayState();

            $(".pop_content").popover();
            setTimeout(function () {
                o._updatePaginationResponsivenes(pagination, 2, 3, 0);
            }, 100);

            // show popover for Ask AIME, if it hasn't been shown yet
            if (
                !$("span.apply_image_match_button").is(":visible") &&
                typeof o.options.ask_aime_popover_displayed === "undefined"
            ) {
                o.options.ask_aime_popover_displayed = true;
                setTimeout(function () {
                    $("span.apply_ask_aime_button").popover("show");
                    $("div.report-keyword-search").popover("show");
                    setTimeout(function () {
                        $("span.apply_ask_aime_button").popover("hide");
                        $("div.report-keyword-search").popover("hide");
                    }, 5000);
                }, 5000);
            }
        },
        /*
         * Vetology.PatientSwissKnife._cornerStoneEnableElement
         *
         * @description	 Enables the tools on an element using the image passed;
         * @cornerstone mouse buttons, touch gestures
         *		1	tool for left mouse button
         *		2	tool for middle mouse button
         *		3	tool for left mouse button and middle mouse button
         *		4	tool for right mouse button
         *		5	tool for left mouse button and right mouse button
         *		6	tool for scroll button
         *		7	tool for touch gesture
         *		8	tool for multi-touch gesture
         *		9	tool for pinch gesture
         *		10	tool for touch and drag gesture
         *
         * @return NULL
         *
         */
        _cornerStoneEnableElement: function (series, element, compare, is_ai) {
            var o = this;
            cornerstone.enable(element);
            element.addEventListener("cornerstoneimagerendered", function () {
                $(element).closest(".loading_workarea").removeClass("loading_workarea");
            });

            // load the progress bar data
            $("body").VetologyCache("unsetDownloadQueue");
            for (const [key, value] of Object.entries(o.options.series.data.all)) {
                $.each(value.stack.imageIds, function (i, crypt) {
                    if (typeof o.options.load_manager.images[crypt] == "undefined") {
                        o.options.load_manager.images[crypt] = {
                            index: i,
                            series: series.cid,
                            series_index: key,
                            loaded: 0,
                            cached: 0,
                            percentComplete: 0,
                            total: 0,
                            is_completed: false,
                            is_im: compare,
                        };
                    }
                });
            }

            o.options.cornerstone.elements.push(element);
            var readyInterval = setInterval(function () {
                if (compare && typeof series.stack_compare == "undefined") {
                    return;
                }
                if ((compare && series.stack_compare.has_matches !== -1) || !compare) {
                    clearInterval(readyInterval);
                    o._cornerStoneLoadSeries(
                        series,
                        element,
                        function (element, image) {
                            /*
									Enable mouse tools
								*/
                            var pagination = $(element).closest(".interface_workarea").find(".pagination_stack_scroll");
                            if (pagination.length > 0) {
                                o._updatePagination(
                                    element,
                                    pagination,
                                    0,
                                    compare ? series.stack_compare : series.stack,
                                    typeof series.stack_compare != "undefined" && compare
                                        ? series.stack_compare.imageDataSet
                                        : typeof series.stack.imageDataSet != "undefined"
                                        ? series.stack.imageDataSet
                                        : false
                                );
                            }
                            if (image) {
                                cornerstone.displayImage(element, image);
                            }
                            cornerstoneTools.mouseInput.enable(element);
                            cornerstoneTools.mouseWheelInput.enable(element);
                            cornerstoneTools.probe.enable(element);
                            cornerstoneTools.length.enable(element);
                            cornerstoneTools.ellipticalRoi.enable(element);
                            cornerstoneTools.rectangleRoi.enable(element);
                            cornerstoneTools.angle.enable(element);
                            cornerstoneTools.simpleAngle.enable(element);
                            cornerstoneTools.freehand.enable(element);
                            cornerstoneTools.brush.enable(element);
                            cornerstoneTools.magnify.enable(element);
                            /*
									Enable touch tools
								*/
                            if (Modernizr.touchevents) {
                                cornerstoneTools.touchInput.enable(element);
                            }
                            /*
									Set canvas specific tool manager
								*/
                            var toolStateManager = cornerstoneTools.newImageIdSpecificToolStateManager();
                            cornerstoneTools.setElementToolStateManager(element, toolStateManager);
                            /*
									Initialize stack for series
								*/
                            cornerstoneTools.addStackStateManager(element, ["stack", "playClip"]);
                            cornerstoneTools.addToolState(
                                element,
                                "stack",
                                compare ? series.stack_compare : series.stack
                            );
                            /*
									Activate mouse and touch elements
								*/
                            o._resetAllCornerstoneTools(o, element);
                            $(element).on("cornerstoneimagerendered", function () {
                                o._updateCornerstoneStackState(element);
                            });
                            o._updateCornerstoneStackState(element);
                            if (compare && typeof o.options.patient.image_match_preload !== "undefined") {
                                var el = $(".pagination_stack_scroll.pagination_compare")
                                    .find('[data-index="' + o.options.patient.image_match_preload + '"]')
                                    .closest("li");
                                el.find("a").click();
                                var r = setInterval(function () {
                                    if (el.hasClass("active")) {
                                        clearInterval(r);
                                        $(".get_matched_report").first().click();
                                    }
                                }, 100);
                            }
                            $.each(o.options.series.data.all, function (i, s) {
                                o._cornerStoneLoadSeries(s);
                                const viewport = cornerstone.getViewport(element);
                                viewport.hflip = false;
                                viewport.rotation = 0;
                                if (
                                    typeof series.dicoms == "object" &&
                                    typeof series.dicoms[series.index] == "object" &&
                                    (series.dicoms[series.index].transformation.rotation != 0 ||
                                        series.dicoms[series.index].transformation.flip)
                                ) {
                                    if (
                                        series.dicoms[series.index].transformation.rotation != 0 &&
                                        o.correctedImagesSwitch.classList.contains("on")
                                    ) {
                                        viewport.rotation = series.dicoms[series.index].transformation.rotation;
                                    }
                                    if (series.dicoms[series.index].transformation.flip) {
                                        viewport.hflip = true;
                                    }
                                }
                                cornerstone.setViewport(element, viewport);
                            });
                        },
                        compare,
                        is_ai
                    );
                }
            }, 100);
        },
        /*
         * Vetology.PatientSwissKnife._cornerStoneLoadSeries
         *
         * @description	 Loads the passed series and callsback a function if passed;
         *
         * @return NULL
         *
         */
        _cornerStoneLoadSeries: function (series, element, callback, compare, is_ai) {
            var o = this;
            var loaded = false;
            var imageindex;
            var stack = compare === true ? series.stack_compare : series.stack;
            if (typeof stack == "undefined") {
                return;
            }
            o.options.load_manager.total += stack.imageIds.length;
            if (typeof element != "undefined" && element != false) {
                $(element).addClass("is_cornerstone_enabled");
            }
            $.each(stack.imageIds, function (i, crypt) {
                if (typeof imageindex === "undefined") {
                    imageindex = i;
                }
                const currentAnnotations = o.options.canvas.image_viewer.element_main.data("current_annotations");
                const currentImageId = o.options.canvas.image_viewer.element_main.data("current_image_id");
                const pixelSpacing = Object.values(series.dicoms)[0].pixel_spacing;
                $.when($("body").VetologyCache("imageReady", crypt, 3, pixelSpacing)).then(
                    function (data) {
                        var url = "vetology:" + crypt;
                        cornerstone.loadAndCacheImage(url).then(
                            function (image) {
                                o.options.download_ended_at =
                                    window.performance &&
                                    window.performance.now &&
                                    window.performance.timing &&
                                    window.performance.timing.navigationStart
                                        ? window.performance.now() + window.performance.timing.navigationStart
                                        : Date.now();
                                if (typeof element != "undefined" && !loaded && imageindex === i) {
                                    loaded = true;
                                    // draw the annotations
                                    let annotations = [];
                                    if (
                                        !o.options.update_annotations &&
                                        stack.imageDataSet[i].image_id == currentImageId &&
                                        currentAnnotations.length > 0
                                    ) {
                                        annotations = currentAnnotations;
                                        o.options.update_annotations = true;
                                    }

                                    const event = new CustomEvent("vetology-image-loaded", {
                                        detail: {
                                            image: image,
                                            annotations: annotations,
                                            image_id: stack.imageDataSet[i].image_id,   // dicoms.id — VETALL-26980 panel sync
                                        },
                                    });
                                    const vCanvas = document.querySelector(".vetology_canvas");
                                    vCanvas.dispatchEvent(event);

                                    if (is_ai) {
                                        o._setReportClass();
                                    }
                                    if (typeof callback == "function") {
                                        callback(element, image);
                                    }
                                }
                            },
                            function (crypt, event) {
                                if (typeof callback == "function" && compare && !is_ai) {
                                    callback(element, null);
                                }
                            }
                        );
                    },
                    function (crypt, event) {
                        if (typeof callback == "function" && compare && !is_ai) {
                            callback(element, null);
                        }
                    }
                );
            });
        },

        /**
         * _setFullTextSearchDisplayState
         *
         * Description Sets the state of the keyword search results
         *
         * @private
         */
        _setFullTextSearchDisplayState: function () {
            var o = this;

            // check if we've done an image match yet
            if (o.options.pagination && o.options.pagination.stack && o.options.pagination.stack.searched_config) {
                // clear any previous keywords
                $("#report-search-text").val("");
                $("#diagnosis-keyword").val("");

                let $ftsResults = $("fieldset.fts-results");

                // check if we already have the FTS results for the currently selected image
                let imageID = o.options.pagination.stack.searched_config.image_id;
                if (o.options.fullTextSearchResults && o.options.fullTextSearchResults[imageID]) {
                    // user already performed keyword search for this image.  Load the keywords and results
                    let data = o.options.fullTextSearchResults[imageID];
                    let diagnosisKeyword = data.diagnosisKeyword;
                    let keywords = data.keywords;
                    $("#report-search-text").val(keywords);
                    if (diagnosisKeyword.length) {
                        $("option[value='" + diagnosisKeyword + "']", "#diagnosis-keyword").prop("selected", "true");
                    }
                    $("#report-search-text").val();
                    $(".results-with-closely-matched-images span", $ftsResults).text(data.withCloselyMatchedImageCount);
                    $(".results-without-closely-matched-images span", $ftsResults).text(
                        data.withoutCloselyMatchedImageCount
                    );
                    $ftsResults.removeClass("hidden");
                    $("#fts-results-btn").attr("href", "/worklist/fts-results/" + imageID);
                } else {
                    $ftsResults.addClass("hidden");
                }
            }
        },

        /*
         * Vetology.PatientSwissKnife._onclickSearchByKeyword
         *
         * @description	 Loads the results of the passed keyword search
         *
         * @return NULL
         *
         */
        _onClickSearchByKeyword: function (event) {
            var o = this;

            // check if user has valid AI License.
            if ($(".search-keyword-btn").hasClass("is_locked")) {
                // no valid license.  Show plans page
                $(".add_license").trigger("click");
                return;
            }

            // if results are visible, hide them
            if (!$(".fts-results").is(":visible")) {
                $(".fts-results").addClass("hidden");
            }

            // check if we already have the FTS results for the currently selected image
            var imageID = this.options.pagination.stack.searched_config.image_id;

            var data = {};
            data.reportSearchText = $("#report-search-text").val().trim();
            if (data.reportSearchText === "") {
                $("textarea#report-search-text").popover("show");
                setTimeout(function () {
                    $("textarea#report-search-text").popover("hide");
                }, 3000);
                return;
            }

            data.diagnosisKeyword = $("option:selected", "#diagnosis-keyword").val();
            data.searchedConfig = this.options.pagination.stack.searched_config;
            data.searchedConfig.image_format = o.options.search_config.image_format;
            data.searchedConfig.rotated = o.options.search_config.rotated;
            data.imageDataSet = $.map(this.options.pagination.stackInfo, function (elem, idx) {
                return {
                    case_id: elem.case_id,
                    image_id: elem.image_id,
                    level: elem.level,
                    has_report: elem.has_report ? 1 : 0,
                    im_matched: 1,
                };
            });
            $("body").Vetology("vetologyLoadStart");

            $.ajax({
                type: "GET",
                url: "/patient-manager/keyword-search",
                data: data,
                dataType: "JSON",
            })
                .done(function (data, textStatus, jqXHR) {
                    $("body").Vetology("vetologyLoadEnd");
                    console.log(data);
                    let $ftsResults = $("fieldset.fts-results");
                    $(".results-with-closely-matched-images span", $ftsResults).text(data.withCloselyMatchedImageCount);
                    $(".results-without-closely-matched-images span", $ftsResults).text(
                        data.withoutCloselyMatchedImageCount
                    );

                    if ($ftsResults.is(":hidden")) {
                        $ftsResults.removeClass("hidden");
                    }
                    $ftsResults.effect("pulsate");

                    // store results in DOM
                    if (!o.options.fullTextSearchResults) {
                        o.options.fullTextSearchResults = [];
                    }
                    o.options.fullTextSearchResults[data.imageID] = data;

                    $("#fts-results-btn").attr("href", "/worklist/fts-results/" + data.imageID);
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    console.log(errorThrown);
                });
        },

        _getPerformImageMatchParams: function () {
            var href = window.location.href;
            var imgMatchIdx = href.indexOf("perform-image-match");
            if (imgMatchIdx !== -1) {
                var qpIdx = location.href.indexOf("perform-image-match");
                var qp = location.href.substr(qpIdx + 20);
                var qpEnd = qp.indexOf("&");
                if (qpEnd !== -1) {
                    qp = qp.substr(0, qpEnd);
                }
                var indexes = qp.split(",");
                if (indexes.length == 2) {
                    var imgMatchParams = {};
                    imgMatchParams.studyIdx = parseInt(indexes[0]);
                    imgMatchParams.imgIdx = parseInt(indexes[1]);
                    return imgMatchParams;
                }
            }
            return false;
        },

        _onClickAskAime: function (event) {
            var o = this;
            var imageInfo = o._getCurrentImageInfo();
            var url = "/patient-manager/ask-aime-question";
            url += "?case_id=" + imageInfo.case_id;
            url += "&image_id=" + imageInfo.image_id;

            o._renderPopUp(url);
        },

        _getCurrentImageInfo: function () {
            var o = this;
            var imageInfo = {};
            if (typeof o.options.pagination.stack.searched_config !== "undefined") {
                imageInfo.case_id = o.options.pagination.stack.searched_config.case_id;
                imageInfo.image_id = o.options.pagination.stack.searched_config.image_id;
            } else {
                imageInfo.case_id = o.options.pagination.stack.imageDataSet[0].case_id;
                imageInfo.image_id = o.options.pagination.stack.imageDataSet[0].image_id;
            }

            return imageInfo;
        },
        aiPromo: function (e) {
            var o = this;
            var form = '<div class="form-group">';
            form += '<label class="control-label col-xs-12 col-sm-4" for="name">Your name:</label>';
            form += '<div class=" col-xs-12 col-sm-8">';
            form += '<input type="text" class="form-control" name="name">';
            form += "</div>";
            form += "</div>";
            form += '<div class="form-group">';
            form += '<label class="control-label col-xs-12 col-sm-4" for="email">Your email address:</label>';
            form += '<div class=" col-xs-12 col-sm-8">';
            form += '<input type="email" class="form-control" name="email">';
            form += "</div>";
            form += "</div>";
            form += '<div class="form-group">';
            form += '<label class="control-label col-xs-12 col-sm-4" for="name_o">Your Colleague\'s name:</label>';
            form += '<div class=" col-xs-12 col-sm-8">';
            form += '<input type="text" class="form-control" name="name_o">';
            form += "</div>";
            form += "</div>";
            form += '<div class="form-group">';
            form +=
                '<label class="control-label col-xs-12 col-sm-4" for="email_o">Your Colleague\'s email address:</label>';
            form += '<div class=" col-xs-12 col-sm-8">';
            form += '<input type="email" class="form-control" name="email_o">';
            form += "</div>";
            form += "</div>";
            form += '<div class="form-group">';
            form += '<label class="control-label col-xs-12 col-sm-4" for="message">Custom message:</label>';
            form += '<div class=" col-xs-12 col-sm-8">';
            form += '<textarea class="form-control" name="message"></textarea>';
            form += "</div>";
            form += "</div>";
            form += '<div class="errors_area"></div>';
            $("body").Vetology(
                "vetologyShowDialog",
                "Share the knowledge:",
                form,
                "info",
                function (fields, modal) {
                    $(".errors_area").html("").removeClass("alert alert-danger");
                    $("body").Vetology("vetologyLoadStart", "Please wait while we send your message");
                    var id = $("body").data("case_id");
                    fields += "&send_knowledge=true&id=" + id;
                    $.ajax({
                        type: "POST",
                        url: "/patient-manager/share-the-knowledge",
                        data: fields,
                        dataType: "JSON",
                        success: function (data) {
                            $("body").Vetology("vetologyLoadEnd");
                            if (data.valid) {
                                $("body").Vetology(
                                    "vetologyShowDialog",
                                    "Thank you for sharing the knowledge",
                                    "We have sent the knowledge on your behalf.<br>Ready to enjoy a free month subscription? click <a href='/sign-up' target='_blank' class='btn btn-primary btn-pink btn-xs'>here</a> to register so you can enroll in the free moth trial",
                                    "success"
                                );
                            } else {
                                $(".errors_area").html(data.errors.join("<br>")).addClass("alert alert-danger");
                            }
                        },
                    }).fail(function (jqXHR, textStatus, errorThrown) {
                        $("body").Vetology("vetologyLoadEnd");
                        let message = "Too many attempts";
                        if (
                            typeof jqXHR.responseJSON != "undefined" &&
                            typeof jqXHR.responseJSON.message != "undefined"
                        ) {
                            message = jqXHR.responseJSON.message;
                        }
                        $("body").Vetology("vetologyShowDialog", "Error", message, "error");
                    });
                },
                "Cancel, maybe later",
                "Send the Knowledge"
            );
        },
        _monitorCaseProcessingStatus: function () {
            let o = this;
            let caseCrypt = $("body").data("case_id");
            o._checkCaseProcessedStatus(caseCrypt).then(function () {
                // give an extra 10 seconds before showing images are ready
                let $caseStatus = $(".case-status.processing");
                $caseStatus.removeClass("processing");
                let curPage = window.location.href;
                $caseStatus.html(
                    $(
                        "<a href='" +
                            curPage +
                            "' title='Refresh Page'>Case Processing Complete.<br/>Click to refresh page.</a>"
                    )
                );
            });
        },
        _checkCaseProcessedStatus: function (caseCrypt) {
            var d = new $.Deferred();

            var checkInterval = setInterval(function () {
                $.getJSON("patient-manager/check-case-status", {
                    caseCrypt: caseCrypt,
                }).done(function (data, textStatus, jqXHR) {
                    if (data.processed && data.processed === true) {
                        clearInterval(checkInterval);
                        d.resolve();
                    }
                });
            }, 3000);

            return d.promise();
        },

        onCorrectedImagesSwitch: function (event) {
            const currentSeriesActivator = document.querySelector(".rendered_studies .study_series_selector .active_series.series_loader:not(.hide) .series_activator");
            $(".study_selector").change();

            const activeStudy = document.querySelector(".rendered_studies .study_series_selector");
            const thumbImgs = activeStudy.querySelectorAll(".series_loader:not(.hide) img");
            thumbImgs.forEach((img) => {
                img.style.removeProperty("transform");
                img.style.transform = "";
                if (this.correctedImagesSwitch.classList.contains("on") && img.dataset.flip == "true") {
                    img.style.transform = "scaleX(-1)";
                }
                const rotation = parseInt(img.dataset.rotation, 10);
                if (this.correctedImagesSwitch.classList.contains("on") && rotation) {
                    img.style.transform += "rotate(" + img.dataset.rotation + "deg)";
                }
            });
            setTimeout(() => {
                // restore active series thumbnail
                if (currentSeriesActivator) {
                    $(currentSeriesActivator).click();
                    // insure activator can be seen
                    currentSeriesActivator.scrollIntoView({ behavior: "smooth", block: "center" });
                }
            }, 2600);
        },
    });
})(jQuery);
